{
  "defaultMessages.ACTIVE_DUTY": "現役軍人",
  "defaultMessages.ARCHITECT": "建築士",
  "defaultMessages.CHILD_CARE_WORKER": "保育士",
  "defaultMessages.COMMUNITY_ELIGIBILITY_PROVISION": "CEP（コミュニティ適格条項、タイトル1/LAP）",
  "defaultMessages.DENTIST": "歯科医師",
  "defaultMessages.DOCTOR": "医師",
  "defaultMessages.EMT": "救急救命士",
  "defaultMessages.FIREFIGHTER": "消防士",
  "defaultMessages.GENERAL_CONTRACTOR": "総合建設業者",
  "defaultMessages.GOLD_STAR_FAMILY": "ゴールドスターファミリー",
  "defaultMessages.GRADUATE": "卒業生",
  "defaultMessages.HOME_BUYER": "住宅購入者",
  "defaultMessages.INTERIOR_DESIGNER": "インテリアデザイナー",
  "defaultMessages.LIBRARIAN": "司書",
  "defaultMessages.LICENSED_COSMETOLOGIST": "有資格美容師",
  "defaultMessages.LICENSED_REAL_ESTATE_AGENT": "宅地建物取引士",
  "defaultMessages.MILITARY_FAMILY": "軍人家族",
  "defaultMessages.MILITARY_RETIREE": "軍退職者",
  "defaultMessages.NURSE": "看護師",
  "defaultMessages.NUTRITION_PROFESSIONAL": "栄養専門家",
  "defaultMessages.OTHER_GOVERNMENT_ASSISTANCE": "その他の政府支援受給者",
  "defaultMessages.OTHER_HEALTH_WORKER": "その他の医療従事者",
  "defaultMessages.OTHER_MOVER": "その他の引越し業者",
  "defaultMessages.PHARMACIST": "薬剤師",
  "defaultMessages.POLICE": "警察官",
  "defaultMessages.RESERVIST": "予備役または州兵",
  "defaultMessages.SEARCH_AND_RESCUE": "捜索救助隊員",
  "defaultMessages.SNAP_BENEFITS": "SNAP給付金受給者",
  "defaultMessages.STUDENT": "学生",
  "defaultMessages.VETERAN": "軍退役者または退職者",
  "defaultMessages.VETERINARIAN": "獣医師",
  "defaultMessages._EXPERIMENTAL.cvecNumberExplanation": "CVECナンバーを追加すると、即時認証の可能性が高まります。",
  "defaultMessages.activeDutyStartDate": "現役開始日",
  "defaultMessages.address": "住所",
  "defaultMessages.addressPlaceholder": "住所",
  "defaultMessages.birthDate": "生年月日",
  "defaultMessages.branchOfService": "兵科",
  "defaultMessages.branchOfServicePlaceholder": "兵科",
  "defaultMessages.cantFindYourSchool": "学校が見つかりませんか？ヒントを表示するにはクリックしてください",
  "defaultMessages.captchaFooterText": "Cloudflareは、不正防止を目的とした本人確認に関連して、お客様の情報を独自に収集し、その<cloudflarePrivacyPolicy>プライバシーポリシー</cloudflarePrivacyPolicy>に従って使用します。",
  "defaultMessages.changeLanguage": "言語を変更",
  "defaultMessages.chooseCountry": "検索前に国を選択してください",
  "defaultMessages.city": "市区町村",
  "defaultMessages.cityPlaceholder": "市区町村",
  "defaultMessages.clearAndOpenMenu": "選択を解除してメニューを開く",
  "defaultMessages.clearSelection": "選択を解除",
  "defaultMessages.close": "閉じる",
  "defaultMessages.closeSection": "セクションを閉じる",
  "defaultMessages.company": "会社名",
  "defaultMessages.companyPlaceholder": "会社名",
  "defaultMessages.copied": "コピーしました",
  "defaultMessages.countries.AD": "アンドラ",
  "defaultMessages.countries.AE": "アラブ首長国連邦",
  "defaultMessages.countries.AF": "アフガニスタン",
  "defaultMessages.countries.AG": "アンティグア・バーブーダ",
  "defaultMessages.countries.AI": "アンギラ",
  "defaultMessages.countries.AL": "アルバニア",
  "defaultMessages.countries.AM": "アルメニア",
  "defaultMessages.countries.AN": "オランダ領アンティル",
  "defaultMessages.countries.AO": "アンゴラ",
  "defaultMessages.countries.AR": "アルゼンチン",
  "defaultMessages.countries.AS": "アメリカ領サモア",
  "defaultMessages.countries.AT": "オーストリア",
  "defaultMessages.countries.AU": "オーストラリア",
  "defaultMessages.countries.AW": "アルバ",
  "defaultMessages.countries.AZ": "アゼルバイジャン",
  "defaultMessages.countries.BA": "ボスニア・ヘルツェゴビナ",
  "defaultMessages.countries.BB": "バルバドス",
  "defaultMessages.countries.BD": "バングラデシュ",
  "defaultMessages.countries.BE": "ベルギー",
  "defaultMessages.countries.BF": "ブルキナファソ",
  "defaultMessages.countries.BG": "ブルガリア",
  "defaultMessages.countries.BH": "バーレーン",
  "defaultMessages.countries.BI": "ブルンジ",
  "defaultMessages.countries.BJ": "ベナン",
  "defaultMessages.countries.BM": "バミューダ",
  "defaultMessages.countries.BN": "ブルネイ",
  "defaultMessages.countries.BO": "ボリビア",
  "defaultMessages.countries.BR": "ブラジル",
  "defaultMessages.countries.BS": "バハマ",
  "defaultMessages.countries.BT": "ブータン",
  "defaultMessages.countries.BV": "ブーベ島",
  "defaultMessages.countries.BW": "ボツワナ",
  "defaultMessages.countries.BY": "ベラルーシ",
  "defaultMessages.countries.BZ": "ベリーズ",
  "defaultMessages.countries.CA": "カナダ",
  "defaultMessages.countries.CD": "コンゴ民主共和国",
  "defaultMessages.countries.CF": "中央アフリカ共和国",
  "defaultMessages.countries.CG": "コンゴ共和国",
  "defaultMessages.countries.CH": "スイス",
  "defaultMessages.countries.CI": "コートジボワール",
  "defaultMessages.countries.CK": "クック諸島",
  "defaultMessages.countries.CL": "チリ",
  "defaultMessages.countries.CM": "カメルーン",
  "defaultMessages.countries.CN": "中国",
  "defaultMessages.countries.CO": "コロンビア",
  "defaultMessages.countries.CR": "コスタリカ",
  "defaultMessages.countries.CU": "キューバ",
  "defaultMessages.countries.CV": "カーボベルデ",
  "defaultMessages.countries.CW": "キュラソー",
  "defaultMessages.countries.CY": "キプロス",
  "defaultMessages.countries.CZ": "チェコ共和国",
  "defaultMessages.countries.DE": "ドイツ",
  "defaultMessages.countries.DJ": "ジブチ",
  "defaultMessages.countries.DK": "デンマーク",
  "defaultMessages.countries.DM": "ドミニカ",
  "defaultMessages.countries.DO": "ドミニカ共和国",
  "defaultMessages.countries.DZ": "アルジェリア",
  "defaultMessages.countries.EC": "エクアドル",
  "defaultMessages.countries.EE": "エストニア",
  "defaultMessages.countries.EG": "エジプト",
  "defaultMessages.countries.EH": "西サハラ",
  "defaultMessages.countries.ER": "エリトリア",
  "defaultMessages.countries.ES": "スペイン",
  "defaultMessages.countries.ET": "エチオピア",
  "defaultMessages.countries.FI": "フィンランド",
  "defaultMessages.countries.FJ": "フィジー",
  "defaultMessages.countries.FK": "フォークランド諸島",
  "defaultMessages.countries.FM": "ミクロネシア",
  "defaultMessages.countries.FO": "フェロー諸島",
  "defaultMessages.countries.FR": "フランス",
  "defaultMessages.countries.GA": "ガボン",
  "defaultMessages.countries.GB": "イギリス",
  "defaultMessages.countries.GD": "グレナダ",
  "defaultMessages.countries.GE": "ジョージア",
  "defaultMessages.countries.GF": "仏領ギアナ",
  "defaultMessages.countries.GH": "ガーナ",
  "defaultMessages.countries.GI": "ジブラルタル",
  "defaultMessages.countries.GL": "グリーンランド",
  "defaultMessages.countries.GM": "ガンビア",
  "defaultMessages.countries.GN": "ギニア",
  "defaultMessages.countries.GP": "グアドループ（仏領）",
  "defaultMessages.countries.GQ": "赤道ギニア",
  "defaultMessages.countries.GR": "ギリシャ",
  "defaultMessages.countries.GS": "サウスジョージア・サウスサンドウィッチ諸島",
  "defaultMessages.countries.GT": "グアテマラ",
  "defaultMessages.countries.GU": "グアム（米国）",
  "defaultMessages.countries.GW": "ギニアビサウ",
  "defaultMessages.countries.GY": "ガイアナ",
  "defaultMessages.countries.HK": "香港",
  "defaultMessages.countries.HM": "ハード島・マクドナルド諸島",
  "defaultMessages.countries.HN": "ホンジュラス",
  "defaultMessages.countries.HR": "クロアチア",
  "defaultMessages.countries.HT": "ハイチ",
  "defaultMessages.countries.HU": "ハンガリー",
  "defaultMessages.countries.ID": "インドネシア",
  "defaultMessages.countries.IE": "アイルランド",
  "defaultMessages.countries.IL": "イスラエル",
  "defaultMessages.countries.IN": "インド",
  "defaultMessages.countries.IO": "英領インド洋地域",
  "defaultMessages.countries.IQ": "イラク",
  "defaultMessages.countries.IR": "イラン",
  "defaultMessages.countries.IS": "アイスランド",
  "defaultMessages.countries.IT": "イタリア",
  "defaultMessages.countries.JM": "ジャマイカ",
  "defaultMessages.countries.JO": "ヨルダン",
  "defaultMessages.countries.JP": "日本",
  "defaultMessages.countries.KE": "ケニア",
  "defaultMessages.countries.KG": "キルギスタン",
  "defaultMessages.countries.KH": "カンボジア",
  "defaultMessages.countries.KI": "キリバス",
  "defaultMessages.countries.KM": "コモロ",
  "defaultMessages.countries.KN": "セントクリストファー・ネイビス",
  "defaultMessages.countries.KP": "北朝鮮",
  "defaultMessages.countries.KR": "韓国",
  "defaultMessages.countries.KW": "クウェート",
  "defaultMessages.countries.KY": "ケイマン諸島",
  "defaultMessages.countries.KZ": "カザフスタン",
  "defaultMessages.countries.LA": "ラオス",
  "defaultMessages.countries.LB": "レバノン",
  "defaultMessages.countries.LC": "セントルシア",
  "defaultMessages.countries.LI": "リヒテンシュタイン",
  "defaultMessages.countries.LK": "スリランカ",
  "defaultMessages.countries.LR": "リベリア",
  "defaultMessages.countries.LS": "レソト",
  "defaultMessages.countries.LT": "リトアニア",
  "defaultMessages.countries.LU": "ルクセンブルク",
  "defaultMessages.countries.LV": "ラトビア",
  "defaultMessages.countries.LY": "リビア",
  "defaultMessages.countries.MA": "モロッコ",
  "defaultMessages.countries.MC": "モナコ",
  "defaultMessages.countries.MD": "モルドバ",
  "defaultMessages.countries.ME": "モンテネグロ",
  "defaultMessages.countries.MG": "マダガスカル",
  "defaultMessages.countries.MH": "マーシャル諸島",
  "defaultMessages.countries.MK": "マケドニア",
  "defaultMessages.countries.ML": "マリ",
  "defaultMessages.countries.MM": "ミャンマー",
  "defaultMessages.countries.MN": "モンゴル",
  "defaultMessages.countries.MO": "マカオ",
  "defaultMessages.countries.MP": "北マリアナ諸島",
  "defaultMessages.countries.MQ": "マルティニーク（仏領）",
  "defaultMessages.countries.MR": "モーリタニア",
  "defaultMessages.countries.MS": "モントセラト",
  "defaultMessages.countries.MT": "マルタ",
  "defaultMessages.countries.MU": "モーリシャス",
  "defaultMessages.countries.MV": "モルディブ",
  "defaultMessages.countries.MW": "マラウイ",
  "defaultMessages.countries.MX": "メキシコ",
  "defaultMessages.countries.MY": "マレーシア",
  "defaultMessages.countries.MZ": "モザンビーク",
  "defaultMessages.countries.NA": "ナミビア",
  "defaultMessages.countries.NC": "ニューカレドニア（仏領）",
  "defaultMessages.countries.NE": "ニジェール",
  "defaultMessages.countries.NF": "ノーフォーク島",
  "defaultMessages.countries.NG": "ナイジェリア",
  "defaultMessages.countries.NI": "ニカラグア",
  "defaultMessages.countries.NL": "オランダ",
  "defaultMessages.countries.NO": "ノルウェー",
  "defaultMessages.countries.NP": "ネパール",
  "defaultMessages.countries.NR": "ナウル",
  "defaultMessages.countries.NU": "ニウエ",
  "defaultMessages.countries.NZ": "ニュージーランド",
  "defaultMessages.countries.OM": "オマーン",
  "defaultMessages.countries.PA": "パナマ",
  "defaultMessages.countries.PE": "ペルー",
  "defaultMessages.countries.PF": "仏領ポリネシア",
  "defaultMessages.countries.PG": "パプアニューギニア",
  "defaultMessages.countries.PH": "フィリピン",
  "defaultMessages.countries.PK": "パキスタン",
  "defaultMessages.countries.PL": "ポーランド",
  "defaultMessages.countries.PM": "サンピエール島・ミクロン島",
  "defaultMessages.countries.PN": "ピトケアン島",
  "defaultMessages.countries.PR": "プエルトリコ",
  "defaultMessages.countries.PS": "パレスチナ",
  "defaultMessages.countries.PT": "ポルトガル",
  "defaultMessages.countries.PW": "パラオ",
  "defaultMessages.countries.PY": "パラグアイ",
  "defaultMessages.countries.QA": "カタール",
  "defaultMessages.countries.RE": "レユニオン（仏領）",
  "defaultMessages.countries.RO": "ルーマニア",
  "defaultMessages.countries.RS": "セルビア",
  "defaultMessages.countries.RU": "ロシア連邦",
  "defaultMessages.countries.RW": "ルワンダ",
  "defaultMessages.countries.SA": "サウジアラビア",
  "defaultMessages.countries.SB": "ソロモン諸島",
  "defaultMessages.countries.SC": "セーシェル",
  "defaultMessages.countries.SD": "スーダン",
  "defaultMessages.countries.SE": "スウェーデン",
  "defaultMessages.countries.SG": "シンガポール",
  "defaultMessages.countries.SH": "セントヘレナ",
  "defaultMessages.countries.SI": "スロベニア",
  "defaultMessages.countries.SK": "スロバキア共和国",
  "defaultMessages.countries.SL": "シエラレオネ",
  "defaultMessages.countries.SM": "サンマリノ",
  "defaultMessages.countries.SN": "セネガル",
  "defaultMessages.countries.SO": "ソマリア",
  "defaultMessages.countries.SR": "スリナム",
  "defaultMessages.countries.SS": "南スーダン",
  "defaultMessages.countries.ST": "サントメ・プリンシペ",
  "defaultMessages.countries.SV": "エルサルバドル",
  "defaultMessages.countries.SY": "シリア",
  "defaultMessages.countries.SZ": "スワジランド",
  "defaultMessages.countries.TC": "タークス・カイコス諸島",
  "defaultMessages.countries.TD": "チャド",
  "defaultMessages.countries.TF": "フランス領南方地域",
  "defaultMessages.countries.TG": "トーゴ",
  "defaultMessages.countries.TH": "タイ",
  "defaultMessages.countries.TJ": "タジキスタン",
  "defaultMessages.countries.TK": "トケラウ",
  "defaultMessages.countries.TL": "東ティモール",
  "defaultMessages.countries.TM": "トルクメニスタン",
  "defaultMessages.countries.TN": "チュニジア",
  "defaultMessages.countries.TO": "トンガ",
  "defaultMessages.countries.TR": "トルコ",
  "defaultMessages.countries.TT": "トリニダード・トバゴ",
  "defaultMessages.countries.TV": "ツバル",
  "defaultMessages.countries.TW": "台湾",
  "defaultMessages.countries.TZ": "タンザニア",
  "defaultMessages.countries.UA": "ウクライナ",
  "defaultMessages.countries.UG": "ウガンダ",
  "defaultMessages.countries.UM": "米国領有小離島",
  "defaultMessages.countries.US": "アメリカ合衆国",
  "defaultMessages.countries.UY": "ウルグアイ",
  "defaultMessages.countries.UZ": "ウズベキスタン",
  "defaultMessages.countries.VA": "バチカン市国",
  "defaultMessages.countries.VC": "セントビンセント・グレナディーン",
  "defaultMessages.countries.VE": "ベネズエラ",
  "defaultMessages.countries.VG": "英領ヴァージン諸島",
  "defaultMessages.countries.VI": "米領ヴァージン諸島",
  "defaultMessages.countries.VN": "ベトナム",
  "defaultMessages.countries.VU": "バヌアツ",
  "defaultMessages.countries.WF": "ウォリス・フツナ諸島",
  "defaultMessages.countries.WS": "サモア",
  "defaultMessages.countries.XK": "コソボ",
  "defaultMessages.countries.YE": "イエメン",
  "defaultMessages.countries.YT": "マヨット",
  "defaultMessages.countries.ZA": "南アフリカ",
  "defaultMessages.countries.ZM": "ザンビア",
  "defaultMessages.countries.ZW": "ジンバブエ",
  "defaultMessages.country": "国",
  "defaultMessages.countryPlaceholder": "国",
  "defaultMessages.cvecNumber": "CVEC証明書番号",
  "defaultMessages.cvecNumberExplanation": "任意 - CVEC番号を入力すると、即時認証される可能性が高まります。",
  "defaultMessages.dateTime.20_MIN": "20分",
  "defaultMessages.dateTime.24_HRS": "24時間",
  "defaultMessages.dateTime.2_DAY": "2日",
  "defaultMessages.dateTime.2_HRS": "2時間",
  "defaultMessages.dateTime.2_MIN": "2分",
  "defaultMessages.dateTime.3_DAY": "3日",
  "defaultMessages.dateTime.A_FEW_DAYS": "数日",
  "defaultMessages.dateTime.A_FEW_HOURS": "数時間",
  "defaultMessages.dateTime.A_FEW_MINUTES": "数分",
  "defaultMessages.dateTime.A_HALF_HOUR": "30分",
  "defaultMessages.dateTime.april": "4月",
  "defaultMessages.dateTime.august": "8月",
  "defaultMessages.dateTime.day": "日",
  "defaultMessages.dateTime.december": "12月",
  "defaultMessages.dateTime.february": "2月",
  "defaultMessages.dateTime.january": "1月",
  "defaultMessages.dateTime.july": "7月",
  "defaultMessages.dateTime.june": "6月",
  "defaultMessages.dateTime.march": "3月",
  "defaultMessages.dateTime.may": "5月",
  "defaultMessages.dateTime.month": "月",
  "defaultMessages.dateTime.november": "11月",
  "defaultMessages.dateTime.october": "10月",
  "defaultMessages.dateTime.september": "9月",
  "defaultMessages.dateTime.year": "年",
  "defaultMessages.dischargeDate": "除隊日",
  "defaultMessages.driverLicenseNumber": "運転免許証番号",
  "defaultMessages.driverLicenseNumberPlaceholder": "運転免許証番号",
  "defaultMessages.driverLicenseState": "運転免許証の発行州",
  "defaultMessages.ebtCardNumber": "EBTカード番号",
  "defaultMessages.emailAddress": "メールアドレス",
  "defaultMessages.emailAddressPlaceholder": "メールアドレス",
  "defaultMessages.error": "認証を続行できませんでした",
  "defaultMessages.errorDetailId.govIdMismatch": "ご入力いただいた情報とIDが一致しませんでした。もう一度お試しください。",
  "defaultMessages.errorDetailId.govIdOtherFailure": "IDの確認中に問題が発生しました。<feedbackFormLink>SheerIDサポートにお問い合わせください</feedbackFormLink>。",
  "defaultMessages.errorDetailId.govIdRetakeBiometric": "モーションキャプチャーの検証中に問題が発生しました。もう一度お試しください：<selfieTipsLink/>。",
  "defaultMessages.errorDetailId.govIdRetakeId": "政府発行IDの検証中に問題が発生しました。もう一度お試しください：<imageTipsLink/>。",
  "defaultMessages.errorDetailId.govIdUnsupportedDoc": "このドキュメントはサポートされていません。対応している政府発行IDで再度お試しください。",
  "defaultMessages.errorDetailId.personLimit": "このオファーはすでに承認されているようです。",
  "defaultMessages.errorDetailId.troubleVerifying": "お客様の確認に問題が発生しているようです。<feedbackFormLink>SheerIDサポートにお問い合わせください</feedbackFormLink>。",
  "defaultMessages.errorDetailId.unableToVerify": "現時点ではお客様の確認ができません。誤りだと思われる場合は、<feedbackFormLink>SheerIDサポートにお問い合わせください</feedbackFormLink>。",
  "defaultMessages.errorDetailId.vpnsNotAllowed": "このプログラムではVPNは許可されていません。VPNをオフにして再度お試しください。誤りだと思われる場合は、<feedbackFormLink>SheerIDサポートにお問い合わせください</feedbackFormLink>。",
  "defaultMessages.errorId.activeDutyStartDateBeforeBirthDate": "開始日は生年月日より後でなければなりません",
  "defaultMessages.errorId.apiRateLimitExceeded": "現在リクエストを処理できません。しばらくしてから再度お試しください",
  "defaultMessages.errorId.dischargeDateBeforeBirthDate": "除隊日が生年月日より前になっています",
  "defaultMessages.errorId.docReviewLimitExceeded": "書類をアップロードいただきありがとうございます。ご提出いただいた書類では、お客様のステータスを確認できませんでした。",
  "defaultMessages.errorId.duplicateFile": "一部のファイルが重複しているようです。別のファイルを選択してください。",
  "defaultMessages.errorId.expiredEmailLoopToken": "ご要望のページが見つかりません。URLが正しくないか、ページが利用できなくなっている可能性があります。",
  "defaultMessages.errorId.expiredProgram": "需要が非常に高いため、オファーはご利用いただけなくなりました。翌日にご確認ください。",
  "defaultMessages.errorId.expiredSMSCode": "確認コードの有効期限が切れています",
  "defaultMessages.errorId.expiredVerification": "この認証は期限切れです。新しい認証を送信してください。",
  "defaultMessages.errorId.failedToFetch": "HTTPリクエストに失敗しました",
  "defaultMessages.errorId.fraudRulesReject": "お客様の情報が正確であること、および VPN やその他のプライバシーソフトウェアを使用していないことをご確認ください。",
  "defaultMessages.errorId.futureActiveDutyStartDate": "開始日が未来の日付になっています",
  "defaultMessages.errorId.futureBirthDate": "生年月日が未来の日付になっています",
  "defaultMessages.errorId.futureDischargeDate": "除隊日が未来の日付になっています",
  "defaultMessages.errorId.inactiveProgram": "需要が非常に高いため、オファーはご利用いただけなくなりました。翌日にご確認ください。",
  "defaultMessages.errorId.incorrectVerificationOverrideCodeAttemptLimitExceeded": "オーバーライドコードの上限を超えました",
  "defaultMessages.errorId.ineligibleOrganization": "選択された組織はこのオファーの基準を満たしていません。",
  "defaultMessages.errorId.internalServerError": "内部サーバーエラー",
  "defaultMessages.errorId.invalidActiveDutyStartDate": "無効な開始日",
  "defaultMessages.errorId.invalidAddress": "無効な住所",
  "defaultMessages.errorId.invalidApiToken": "提供されたAPIトークンが無効または空です",
  "defaultMessages.errorId.invalidAuthenticationLoopToken": "提供されたコードは無効です",
  "defaultMessages.errorId.invalidBirthDate": "無効な生年月日",
  "defaultMessages.errorId.invalidCaptchaToken": "キャプチャ認証に失敗しました。",
  "defaultMessages.errorId.invalidCity": "無効な市区町村",
  "defaultMessages.errorId.invalidCountry": "無効な国",
  "defaultMessages.errorId.invalidCvecNumber": "無効なCVEC証明書番号",
  "defaultMessages.errorId.invalidDischargeDate": "無効な除隊日",
  "defaultMessages.errorId.invalidDocUploadToken": "提供されたドキュメントアップロードトークンが無効です",
  "defaultMessages.errorId.invalidDriverLicenseNumber": "無効な運転免許証番号",
  "defaultMessages.errorId.invalidEbtCardNumber": "無効なEBTカード番号",
  "defaultMessages.errorId.invalidEmail": "無効なメールアドレス",
  "defaultMessages.errorId.invalidEmailLoopToken": "ご要望のページが見つかりません。URLが正しくないか、ページが利用できなくなっている可能性があります。",
  "defaultMessages.errorId.invalidFileSizeEmpty": "1つ以上のファイルが空です",
  "defaultMessages.errorId.invalidFileSizeMax": "1つ以上のファイルが大きすぎます（最大：10MB）",
  "defaultMessages.errorId.invalidFirstName": "無効な名前",
  "defaultMessages.errorId.invalidFirstResponderStatus": "無効な緊急対応者ステータス",
  "defaultMessages.errorId.invalidLastName": "無効な姓",
  "defaultMessages.errorId.invalidMemberId": "無効なID番号",
  "defaultMessages.errorId.invalidMilitaryStatus": "無効な軍事ステータス",
  "defaultMessages.errorId.invalidNumberOfFiles": "ファイル数の上限を超えました（最大：5件）",
  "defaultMessages.errorId.invalidOptIn": "続行するには選択が必要です",
  "defaultMessages.errorId.invalidOrganization": "リストから組織を選択してください",
  "defaultMessages.errorId.invalidOverrideCode": "無効なオーバーライドコード",
  "defaultMessages.errorId.invalidPhoneNumber": "無効な携帯電話番号",
  "defaultMessages.errorId.invalidPostalCode": "無効な郵便番号",
  "defaultMessages.errorId.invalidProgram": "無効なプログラム",
  "defaultMessages.errorId.invalidRequest": "無効なリクエスト",
  "defaultMessages.errorId.invalidSMSCode": "確認コードを検証できませんでした",
  "defaultMessages.errorId.invalidSocialSecurityNumber": "無効な社会保障番号",
  "defaultMessages.errorId.invalidState": "無効な州",
  "defaultMessages.errorId.invalidStatus": "無効なステータス",
  "defaultMessages.errorId.invalidStatuses": "無効なステータス",
  "defaultMessages.errorId.invalidStep": "無効なステップ",
  "defaultMessages.errorId.marketConsentRequired": "市場同意が必要です",
  "defaultMessages.errorId.maxMetadataLengthExceeded": "メタデータ値の最大長を超えました",
  "defaultMessages.errorId.maxMetadataValuesExceeded": "メタデータ値の最大数を超えました",
  "defaultMessages.errorId.missingRequiredExternalId": "確認するにはログインが必要です。アカウントにログインしてから再度お試しください。",
  "defaultMessages.errorId.missingRequiredMetadata": "確認するにはログインが必要です。アカウントにログインしてから再度お試しください。",
  "defaultMessages.errorId.noProgram": "プログラムが見つかりません",
  "defaultMessages.errorId.noRemainingRewardCodes": "需要が非常に高いため、オファーはご利用いただけなくなりました。翌日にご確認ください。",
  "defaultMessages.errorId.noValidFiles": "有効なファイルがありません",
  "defaultMessages.errorId.noVerification": "認証が見つかりません",
  "defaultMessages.errorId.notApproved": "承認されていません",
  "defaultMessages.errorId.notFound": "見つかりません",
  "defaultMessages.errorId.outsideAgePerson": "生年月日はこのオファーの対象外です。",
  "defaultMessages.errorId.requestTimeout": "リクエストタイムアウト",
  "defaultMessages.errorId.simulatedError": "これはシミュレートされたエラーです",
  "defaultMessages.errorId.unauthorizedAccountStatus": "このオファーは一時的に停止されています。詳細については、ブランドのカスタマーサポートにお問い合わせください。",
  "defaultMessages.errorId.unauthorizedDomain": "許可されていないドメイン",
  "defaultMessages.errorId.underagePerson": "16歳未満の方はこのオファーをご利用いただけません。",
  "defaultMessages.errorId.unknownError": "不明なエラー",
  "defaultMessages.errorId.unsupportedDocMimeType": "1つ以上のファイルが対応していない形式です",
  "defaultMessages.errorId.verificationLimitExceeded": "このオファーはすでに使用されたか、使用が試みられた可能性があります。",
  "defaultMessages.experiment.step.docUpload.documentConsiderations": "書類に関する注意事項",
  "defaultMessages.firstName": "名",
  "defaultMessages.firstNamePlaceholder": "名",
  "defaultMessages.firstResponderInfoShared": "ここに入力された情報は、確認目的に使用されます。",
  "defaultMessages.footerText": "上記の個人情報を送信することにより、私は割引を申請している事業者の<privacyPolicy>プライバシーポリシー</privacyPolicy>に基づいて個人情報が収集されることを認め、SheerIDが特別オファーの資格を確認するためにプロセッサー/第三者サービスプロバイダーとして私の個人情報をSheerIDと共有することを理解します。<aboutSheerID>SheerIDについて詳しく。</aboutSheerID>",
  "defaultMessages.footerText_sso": "続行することで、お客様は割引を求めている企業に代わってプロセッサー/第三者サービスプロバイダーとしての役割を果たすSheerIDと個人情報を共有することに同意します。お客様の確認のために収集された個人情報は、お客様が割引を求めている企業のプライバシーポリシーに従って処理されることを認めます。<aboutSheerID>SheerIDについて詳しく。</aboutSheerID>",
  "defaultMessages.getHelp": "ヘルプを取得",
  "defaultMessages.graduationStatus": "卒業状況",
  "defaultMessages.howDoesReviewWork": "審査はどのように機能しますか？",
  "defaultMessages.howDoesVerifyingWork": "確認はどのように機能しますか？",
  "defaultMessages.infoShared1": "クリックすることにより、{privacyPolicyLink}に記載された目的のために、私の資格を確認する目的で私の情報を処理することに同意します",
  "defaultMessages.infoShared2": "。私の情報が{companyName}と共有されることを理解します。",
  "defaultMessages.informationTransferredToUS": "お客様の情報は米国に転送され、SheerIDのプライバシーポリシーに従って取り扱われます。",
  "defaultMessages.instant": "即時",
  "defaultMessages.lastName": "姓",
  "defaultMessages.lastNamePlaceholder": "姓",
  "defaultMessages.limitExceededError": "この確認を続行できませんでした",
  "defaultMessages.loading": "読み込み中...",
  "defaultMessages.locales.ar": "العربية",
  "defaultMessages.locales.bg": "български",
  "defaultMessages.locales.bn-IN": "বাংলা (ভারত)",
  "defaultMessages.locales.cs": "čeština",
  "defaultMessages.locales.da": "Dansk",
  "defaultMessages.locales.de": "Deutsch",
  "defaultMessages.locales.el": "Ελληνικά",
  "defaultMessages.locales.en-GB": "English (UK)",
  "defaultMessages.locales.en-US": "English",
  "defaultMessages.locales.es": "Español",
  "defaultMessages.locales.es-ES": "Español (España)",
  "defaultMessages.locales.et": "eesti",
  "defaultMessages.locales.fa": "فارسی",
  "defaultMessages.locales.fi": "suomi",
  "defaultMessages.locales.fr": "Français",
  "defaultMessages.locales.fr-CA": "Français (Canada)",
  "defaultMessages.locales.ga": "Gaeilge",
  "defaultMessages.locales.hi-IN": "हिंदी (भारत)",
  "defaultMessages.locales.hr": "hrvatski",
  "defaultMessages.locales.hu": "magyar",
  "defaultMessages.locales.id": "Bahasa Indonesia",
  "defaultMessages.locales.is": "Íslenska",
  "defaultMessages.locales.it": "Italiano",
  "defaultMessages.locales.iw": "עברית",
  "defaultMessages.locales.ja": "日本語",
  "defaultMessages.locales.kk": "Қазақ",
  "defaultMessages.locales.ko": "한국어",
  "defaultMessages.locales.lo": "ລາວ",
  "defaultMessages.locales.lt": "Lietuvių",
  "defaultMessages.locales.lv": "Latviešu",
  "defaultMessages.locales.ms": "Bahasa Melayu",
  "defaultMessages.locales.nl": "Nederlands",
  "defaultMessages.locales.nl-BE": "Vlaams",
  "defaultMessages.locales.no": "Norsk",
  "defaultMessages.locales.pl": "Polski",
  "defaultMessages.locales.pt": "Português",
  "defaultMessages.locales.pt-BR": "Português (Brasil)",
  "defaultMessages.locales.ro": "Română",
  "defaultMessages.locales.ru": "Русский",
  "defaultMessages.locales.sk": "slovenský",
  "defaultMessages.locales.sl": "Slovenščina",
  "defaultMessages.locales.sr": "Српски",
  "defaultMessages.locales.sv": "Svenska",
  "defaultMessages.locales.sw": "Kiswahili",
  "defaultMessages.locales.ta": "தமிழ்",
  "defaultMessages.locales.th": "ไทย",
  "defaultMessages.locales.tl": "Filipino",
  "defaultMessages.locales.tr": "Türkçe",
  "defaultMessages.locales.uk": "Українська",
  "defaultMessages.locales.ur": "اردو",
  "defaultMessages.locales.vi": "Tiếng Việt",
  "defaultMessages.locales.zh": "中文（繁体）",
  "defaultMessages.locales.zh-HK": "中文（香港）",
  "defaultMessages.locales.zu": "IsiZulu",
  "defaultMessages.lowIncomeOrganization": "政府支援プログラム",
  "defaultMessages.lowIncomeOrganizationPlaceholder": "政府支援プログラム",
  "defaultMessages.lowRewardPool": "&#128293; 残り{offersRemaining}件のオファーのみ！",
  "defaultMessages.memberId": "ID番号",
  "defaultMessages.memberIdPlaceholder": "ID番号",
  "defaultMessages.militaryFamilyCardNote": "注意：このオファーは扶養家族IDカードを持つ軍人家族のみが利用できます。",
  "defaultMessages.militaryInfoShared": "ここに入力された情報は本人確認の目的に使用されます。",
  "defaultMessages.militaryStatus": "軍人ステータス",
  "defaultMessages.multipleLocationsTips": "学術機関に複数のキャンパスがあり、ご自身のものが見つからない場合は、メインのキャンパスを入力してください。",
  "defaultMessages.noOptions": "オプションなし",
  "defaultMessages.openMenu": "メニューを開く",
  "defaultMessages.optIn": "はい、{company}のマーケティング通信（限定セール、特別オファー、最新製品など）を送ってください",
  "defaultMessages.optional": "任意",
  "defaultMessages.orgSearchSortAccessibilityLabel": "検索結果を並び替え",
  "defaultMessages.orgSearchSortByDistance": "距離順に並び替え",
  "defaultMessages.orgSearchSortByRelevance": "関連性順に並び替え",
  "defaultMessages.organization": "組織",
  "defaultMessages.organizationPlaceholder": "組織",
  "defaultMessages.personalInformation": "個人情報",
  "defaultMessages.personalOrSchoolIsFine": "個人またはスクールのメールアドレスで構いません",
  "defaultMessages.phoneNumber": "携帯電話番号",
  "defaultMessages.phoneNumberExplanation": "任意 - ステータス更新のSMSテキスト通知を受け取る",
  "defaultMessages.phoneNumberWarnMessage1": "携帯電話番号を入力してこのフォームを送信することで、確認目的でSMS/テキストメッセージを受け取ることに同意します。携帯電話会社の標準的なテキストメッセージ（SMS）およびデータ料金が適用される場合があります。",
  "defaultMessages.phoneNumberWarnMessage2": "本人確認および不正防止のためにのみ、携帯電話サービスプロバイダーがお客様の携帯電話番号および特定のアカウント情報をSheerIDに開示することを許可します。",
  "defaultMessages.phoneUsPlaceholder": "555-555-5555",
  "defaultMessages.postalCode": "郵便番号",
  "defaultMessages.postalCodeExplanation": "ライセンス機関に登録されている住所をご使用ください",
  "defaultMessages.postalCodePlaceholder": "郵便番号",
  "defaultMessages.poweredBy": "SheerIDが提供する本人確認サービス",
  "defaultMessages.privacyPolicy": "プライバシーポリシー",
  "defaultMessages.proceed": "続行",
  "defaultMessages.requestSchool": "学校が見つかりませんか？追加リクエストをしてください。",
  "defaultMessages.requiredFields": "* 必須情報",
  "defaultMessages.rewardCodeEmailNotification": "新しいコードをすぐに、または後で使用できるよう、コピーをメールで送りました。verify@sheerid.comからのメールをご確認ください。",
  "defaultMessages.school": "学校",
  "defaultMessages.schoolName": "学校",
  "defaultMessages.schoolNamePlaceholder": "学校",
  "defaultMessages.sheeridFaqs": "SheerID よくある質問",
  "defaultMessages.smsCodePlaceholder": "SMSコード",
  "defaultMessages.ssn": "社会保障番号",
  "defaultMessages.ssnPlaceholder": "000-00-0000",
  "defaultMessages.state": "州",
  "defaultMessages.statePlaceholder": "州",
  "defaultMessages.states.AK": "アラスカ州",
  "defaultMessages.states.AL": "アラバマ州",
  "defaultMessages.states.AR": "アーカンソー州",
  "defaultMessages.states.AS": "アメリカ領サモア",
  "defaultMessages.states.AZ": "アリゾナ州",
  "defaultMessages.states.CA": "カリフォルニア州",
  "defaultMessages.states.CO": "コロラド州",
  "defaultMessages.states.CT": "コネチカット州",
  "defaultMessages.states.DC": "コロンビア特別区",
  "defaultMessages.states.DE": "デラウェア州",
  "defaultMessages.states.FL": "フロリダ州",
  "defaultMessages.states.GA": "ジョージア州",
  "defaultMessages.states.GU": "グアム",
  "defaultMessages.states.HI": "ハワイ州",
  "defaultMessages.states.IA": "アイオワ州",
  "defaultMessages.states.ID": "アイダホ州",
  "defaultMessages.states.IL": "イリノイ州",
  "defaultMessages.states.IN": "インディアナ州",
  "defaultMessages.states.KS": "カンザス州",
  "defaultMessages.states.KY": "ケンタッキー州",
  "defaultMessages.states.LA": "ルイジアナ州",
  "defaultMessages.states.MA": "マサチューセッツ州",
  "defaultMessages.states.MD": "メリーランド州",
  "defaultMessages.states.ME": "メイン州",
  "defaultMessages.states.MI": "ミシガン州",
  "defaultMessages.states.MN": "ミネソタ州",
  "defaultMessages.states.MO": "ミズーリ州",
  "defaultMessages.states.MS": "ミシシッピ州",
  "defaultMessages.states.MT": "モンタナ州",
  "defaultMessages.states.NC": "ノースカロライナ州",
  "defaultMessages.states.ND": "ノースダコタ州",
  "defaultMessages.states.NE": "ネブラスカ州",
  "defaultMessages.states.NH": "ニューハンプシャー州",
  "defaultMessages.states.NJ": "ニュージャージー州",
  "defaultMessages.states.NM": "ニューメキシコ州",
  "defaultMessages.states.NV": "ネバダ州",
  "defaultMessages.states.NY": "ニューヨーク州",
  "defaultMessages.states.OH": "オハイオ州",
  "defaultMessages.states.OK": "オクラホマ州",
  "defaultMessages.states.OR": "オレゴン州",
  "defaultMessages.states.PA": "ペンシルベニア州",
  "defaultMessages.states.PR": "プエルトリコ",
  "defaultMessages.states.RI": "ロードアイランド州",
  "defaultMessages.states.SC": "サウスカロライナ州",
  "defaultMessages.states.SD": "サウスダコタ州",
  "defaultMessages.states.TN": "テネシー州",
  "defaultMessages.states.TX": "テキサス州",
  "defaultMessages.states.UT": "ユタ州",
  "defaultMessages.states.VA": "バージニア州",
  "defaultMessages.states.VI": "バージン諸島",
  "defaultMessages.states.VT": "バーモント州",
  "defaultMessages.states.WA": "ワシントン州",
  "defaultMessages.states.WI": "ウィスコンシン州",
  "defaultMessages.states.WV": "ウェストバージニア州",
  "defaultMessages.states.WY": "ワイオミング州",
  "defaultMessages.status": "ステータス",
  "defaultMessages.statusPlaceholder": "ステータス",
  "defaultMessages.step.collectIdentifier.inputExplanation": "認証コードを送信するために必要",
  "defaultMessages.step.collectIdentifier.submitButton": "続ける",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdExplanation": "専門職会員登録番号",
  "defaultMessages.step.collectMedicalPersonalInfo.autorisationsIdLabel": "登録番号",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerExplanation": "専門職会員登録番号",
  "defaultMessages.step.collectMedicalPersonalInfo.gbrNummerLabel": "登録番号",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberExplanation": "専門職会員登録番号",
  "defaultMessages.step.collectMedicalPersonalInfo.globalLocationNumberLabel": "グローバルロケーション番号",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoExplanation": "専門職会員登録番号",
  "defaultMessages.step.collectMedicalPersonalInfo.numeroColegiadoLabel": "登録番号",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberExplanation": "専門職会員登録番号",
  "defaultMessages.step.collectMedicalPersonalInfo.registrationNumberLabel": "登録番号",
  "defaultMessages.step.collectPersonalInfo.submitButton": "私の{segment}ステータスを確認する",
  "defaultMessages.step.collectSocialSecurityNumber.selectOption": "オプションを選択",
  "defaultMessages.step.collectSocialSecurityNumber.title": "社会保障番号を入力してください",
  "defaultMessages.step.collectSocialSecurityNumber.uploadDoc": "書類をアップロード",
  "defaultMessages.step.collectSocialSecurityNumber.uploadInstead": "代わりに書類をアップロード",
  "defaultMessages.step.collectSocialSecurityNumber.useSsn": "社会保障番号で確認する",
  "defaultMessages.step.completeAuthentication.manuallyVerifyButton": "手動で確認する",
  "defaultMessages.step.completeAuthentication.subtitle": "メールに送信されたコードを入力してください。",
  "defaultMessages.step.completeAuthentication.title": "「Remember Me」で確認する",
  "defaultMessages.step.consolation.subtitle": "認証はできませんでしたが、{companyName} よりこのコードをご提供いたします。このコードはお客様専用で、一度のみご利用いただけます。",
  "defaultMessages.step.consolation.title": "オファーを受け取る",
  "defaultMessages.step.consolation.verificationOnly": "この特典に関するご質問は、{companyName} までお問い合わせください。",
  "defaultMessages.step.docUpload.acceptableUploadExamples": "受け入れ可能な例には以下が含まれます：",
  "defaultMessages.step.docUpload.acceptableUploads.age.birthCertificate": "出生証明書",
  "defaultMessages.step.docUpload.acceptableUploads.age.driversLicense": "運転免許証",
  "defaultMessages.step.docUpload.acceptableUploads.age.passport": "パスポート",
  "defaultMessages.step.docUpload.acceptableUploads.age.stateId": "州発行のID",
  "defaultMessages.step.docUpload.acceptableUploads.doNotUploadMilitaryIdContent": "連邦法に従い、SheerIDは現役/予備役の軍人IDカードの提出を受け付けません。",
  "defaultMessages.step.docUpload.acceptableUploads.doNotUploadMilitaryIdTitle": "軍人IDの写真をアップロードしないでください。",
  "defaultMessages.step.docUpload.acceptableUploads.employment.employeeIdCard": "従業員IDカード",
  "defaultMessages.step.docUpload.acceptableUploads.employment.officialLetter": "公式の書状",
  "defaultMessages.step.docUpload.acceptableUploads.employment.payStub": "直近90日以内の給与明細",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.idCard": "IDカード",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.letter": "公式書状",
  "defaultMessages.step.docUpload.acceptableUploads.firstResponder.payStub": "直近60日以内の給与明細",
  "defaultMessages.step.docUpload.acceptableUploads.licensedProfessional.license": "ライセンス証明書",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.program": "選択した政府支援プログラムの資格を証明するカードの表裏。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programApprovalLetter": "選択した政府支援プログラムの政府機関が発行した承認書（例：補足的保障所得（SSI）の受給資格書）。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programApprovalScreenshot": "選択した政府支援プログラムのオンラインポータルのスクリーンショットで、資格があることを示すもの（オンラインアカウントのMedicaid申請状況のスクリーンショット）。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programBankStatement": "選択した給付の最近の支払いを示す銀行取引明細書。",
  "defaultMessages.step.docUpload.acceptableUploads.lowIncome.programCard": "選択した政府支援プログラムの資格を証明するカードの表裏（例：SNAPプログラムのEBTカード）。",
  "defaultMessages.step.docUpload.acceptableUploads.medical.idCard": "IDバッジ",
  "defaultMessages.step.docUpload.acceptableUploads.medical.letterEmployment": "直近90日以内の日付が記された会社レターヘッドの在職証明書",
  "defaultMessages.step.docUpload.acceptableUploads.medical.licenseCertificate": "医療免許または証明書",
  "defaultMessages.step.docUpload.acceptableUploads.medical.payStub": "直近90日以内の給与明細",
  "defaultMessages.step.docUpload.acceptableUploads.medical.photoPayStub": "写真付きIDと最近の給与明細",
  "defaultMessages.step.docUpload.acceptableUploads.member.idCard": "会員証明書",
  "defaultMessages.step.docUpload.acceptableUploads.member.payStub": "直近90日以内の給与明細",
  "defaultMessages.step.docUpload.acceptableUploads.military.active.leaveEarningStatement": "休暇・給与明細書（直近90日以内の日付のもの）",
  "defaultMessages.step.docUpload.acceptableUploads.military.active.uniformedServicesId": "制服部隊IDカード",
  "defaultMessages.step.docUpload.acceptableUploads.military.activeDuty": "現在30日以上、軍隊で現役として服務していることを証明するあらゆる書類",
  "defaultMessages.step.docUpload.acceptableUploads.military.dependent": "あなたが法的に提出できる、登録済み軍人家族であることを証明するあらゆる書類。",
  "defaultMessages.step.docUpload.acceptableUploads.military.goldStarFamily": "DD1300フォーム/死傷者報告書（申請者が故人の家族であることを示すもの）",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.blueUniformedId": "退職者ステータスを示す制服部隊IDカード",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.dd214Form": "DD214 <em>(20年以上の服役歴がある、または障害評価が30%以上の場合)</em>",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.retireeId": "退職者ID",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.vaDigitalId": "VA Digital ID <em>(20年以上の服役歴がある、または障害評価が30%以上の場合)</em>",
  "defaultMessages.step.docUpload.acceptableUploads.military.militaryRetiree.vaHealthBenefitsCard": "VA医療給付書（障害評価が30%以上の場合）",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservist.leaveEarningStatement": "休暇・給与明細書（直近90日以内の日付のもの）",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservist.uniformedServicesId": "制服部隊IDカード",
  "defaultMessages.step.docUpload.acceptableUploads.military.reservistA": "現在、軍隊の予備役部門で服務していることを示すあらゆる書類",
  "defaultMessages.step.docUpload.acceptableUploads.military.retiree": "軍隊の退職者であることを証明するあらゆる書類",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.dd214Form": "DD214フォーム",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.departmentVeteranId": "退役軍人省のIDカード",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.dischargeCertificate": "除隊証明書",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.driverLicenseVeteran": "退役軍人指定の運転免許証",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.vaDigitalId": "VAデジタルID",
  "defaultMessages.step.docUpload.acceptableUploads.military.vet.vaHealthBenefitsCard": "VA医療給付カード",
  "defaultMessages.step.docUpload.acceptableUploads.military.veteran": "軍事服務の資格を満たし、名誉除隊となったことを証明するあらゆる書類",
  "defaultMessages.step.docUpload.acceptableUploads.officialLetter": "公式書状",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.changeOfAddress": "米国郵便公社の住所変更確認書",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.mortgageDeed": "抵当証書",
  "defaultMessages.step.docUpload.acceptableUploads.recentMover.rentalAgreement": "賃貸契約",
  "defaultMessages.step.docUpload.acceptableUploads.senior.birthCertificate": "出生証明書",
  "defaultMessages.step.docUpload.acceptableUploads.senior.driversLicense": "運転免許証",
  "defaultMessages.step.docUpload.acceptableUploads.senior.passport": "パスポート",
  "defaultMessages.step.docUpload.acceptableUploads.senior.stateId": "州発行のID",
  "defaultMessages.step.docUpload.acceptableUploads.student.classSchedule": "時間割",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.alumniCard": "卒業生／同窓会カード",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.diploma": "卒業証書のコピー",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.letterOfCompletion": "教務課発行の修了証明書",
  "defaultMessages.step.docUpload.acceptableUploads.student.graduate.transcript": "公式または非公式の成績証明書",
  "defaultMessages.step.docUpload.acceptableUploads.student.idCard": "有効期限付き学生IDカード",
  "defaultMessages.step.docUpload.acceptableUploads.student.tuitionReceipt": "授業料の領収書",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.idCard": "教育者IDカード",
  "defaultMessages.step.docUpload.acceptableUploads.teacher.payStub": "直近90日以内の給与明細",
  "defaultMessages.step.docUpload.acceptedTypes": "ファイルは .jpg .jpeg .png .pdf 形式である必要があります",
  "defaultMessages.step.docUpload.addFile": "書類を追加",
  "defaultMessages.step.docUpload.allowedDocuments": "法的に提供が許可されている書類のみをアップロードしてください。",
  "defaultMessages.step.docUpload.canIFinishLater": "後で完了できますか？",
  "defaultMessages.step.docUpload.canIFinishLaterDetails": "はい、今完了しない場合は、ご提供いただいたアドレスにこのステップへ戻るリンクが記載されたメールを自動的に送信します。",
  "defaultMessages.step.docUpload.documentReviewProcess": "書類は、人手と自動書類審査の最適な組み合わせにより真正性が確認され、お客様が提供した情報と照合されます。",
  "defaultMessages.step.docUpload.documentsMustInclude": "書類、または書類の組み合わせには、次の内容が含まれている必要があります。",
  "defaultMessages.step.docUpload.nameChanged": "書類発行後にお名前が変わった場合は、公式な改名を示す2枚目の書類をアップロードしてください。",
  "defaultMessages.step.docUpload.rejectedNextStep": "これを修正して、もう一度お試しください。",
  "defaultMessages.step.docUpload.rejectedSubtitle": "以下の理由により、資格を確認できませんでした：",
  "defaultMessages.step.docUpload.rejectionReasons.CUSTOM_VALUE_OTHER": "提出された書類には、このオファーの資格を証明するための要件が欠けています。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_DATE_OTHER": "提出された書類は、このオファーの資格を証明するための日付要件を満たしていません。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EMAIL_SCREENSHOT": "メールのスクリーンショットは受け付けできません。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_EXPIRED": "書類はすでに期限切れか、発行からかなり時間が経っています。より新しい書類をアップロードしてください。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_HANDWRITTEN": "手書きの書類は受け付けできません。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_LIKELY_FRAUD": "このオファーの資格を証明するには書類が不十分です。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED": "ご提出の書類には発行日が記載されていないか、発行からかなり時間が経っています。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_OUTDATED_FACULTY": "ご提出の書類は、現在の学年度における雇用を証明していません。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_PASSWORD_PROTECTED": "パスワードで保護された書類は受け付けできません。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_STATUS_OTHER": "提出された書類には、このオファーの資格を証明するには不十分なステータスが記載されています。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_TOO_FUTURE": "書類に記載されている日付が未来に遠すぎます。現在の状況を証明する、より新しい書類をアップロードしてください。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNREADABLE": "画像の品質が低いため、書類を読み取れませんでした。明瞭で鮮明な画像を用意し、再度提出してください。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_UNSUPPORTED": "書類が公式なものではないか、受け付け可能な書類の種類リストにありません。",
  "defaultMessages.step.docUpload.rejectionReasons.DOCUMENT_VALID_OTHER": "提出された書類は、このオファーの資格を確認することができません。",
  "defaultMessages.step.docUpload.rejectionReasons.EBT_CARD_NUMBER_OTHER": "提出されたEBTカードは、このオファーの資格を確認することができません。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_JOB_TITLE": "書類に記載されている職名はこのオファーの対象外です。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_ORGANIZATION": "ご提出の書類に記載された組織はこのオファーの対象外です。",
  "defaultMessages.step.docUpload.rejectionReasons.INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT": "高校生はこのオファーの対象外です。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_CUSTOM_VALUE": "書類には、このオファーの資格を確認するために必要な情報が不足しています。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_DOCUMENT_DATE": "書類に記載されている日付は、現在の状況を証明するには不十分です。最近の月と年が含まれている書類をアップロードしてください。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_EBT_CARD_NUMBER": "アップロードされたEBTカードは、このオファーの資格を確認するには不十分です。",
  "defaultMessages.step.docUpload.rejectionReasons.INSUFFICIENT_STATUS": "書類は、このオファーの対象となるステータスをお持ちであることを証明していません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_BIRTHDATE": "書類の生年月日が、確認フォームに入力した生年月日と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_COMPANY_NAME_OR_ADDRESS": "書類に記載された会社名または住所が、確認フォームに入力した内容と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_CUSTOM_VALUE": "書類に表示されている一部の情報が、確認フォームに入力した内容と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_EBT_CARD_NUMBER": "アップロードされたEBTカードの番号が、確認フォームに入力された番号と異なります。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION": "提出した書類の機関名が、確認フォームに記載した機関名と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_COUNTRY": "確認フォームで選択した国が、提出した書類に記載されている国と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_ORGANIZATION_NAME": "確認フォームに入力した機関名が、提出した書類に記載されている機関名と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_FIRST_NAME": "書類の名が、確認フォームに入力した名と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_LAST_NAME": "確認フォームに入力した姓が、提出した書類に記載されている名前と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_PERSON_NAME": "提出した書類の情報が、確認フォームに提出した名および/または姓と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISMATCH_STATUS": "書類のステータスが、確認フォームに入力したステータスと一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_CUSTOM_VALUE": "このオファーに対するあなたの資格を証明するために必要な情報が書類に欠けています。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_DOCUMENT_DATE": "現在の日付が欠けています。現在の状況を証明する公式の日付入り書類をアップロードしてください。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_EBT_CARD_NUMBER": "アップロードされたEBTカードにカード番号が欠けています。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION": "提出した書類には、このオファーへの資格を判断するために必要な情報がすべて記載されていません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES": "提出した書類には、米国軍の対象部門への所属が示されていません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_BIRTHDATE": "生年月日が欠けています。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_ORGANIZATION_NAME": "確認フォームに入力した機関名が、提出した書類に記載されていません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_PERSON_NAME": "提出した書類に名および/または姓が欠けています。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_INFORMATION_UNIVERSITY_ENROLLMENT": "提出した書類は、現在の学期における在籍を証明していません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_OR_MISMATCH_JOB_TITLE": "提出した書類の役職が欠けているか、確認フォームに入力した内容と一致しません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_FIRST_NAME": "提出した書類にあなたの名が記載されていません。",
  "defaultMessages.step.docUpload.rejectionReasons.MISSING_PERSON_LAST_NAME": "提出した書類にあなたの姓が記載されていません。",
  "defaultMessages.step.docUpload.rejectionReasons.ORGANIZATION_NAME_OTHER": "提出した書類に示された機関名が、確認フォームに記載されたものと異なりました。",
  "defaultMessages.step.docUpload.rejectionReasons.OTHER_CONTACT_US": "このオファーに対するあなたの資格の確認に問題が発生しています。ヘルプについては、SheerIDのカスタマーサービスにお問い合わせください：customerservice@sheerid.com",
  "defaultMessages.step.docUpload.rejectionReasons.OUT_OF_RANGE_BIRTHDATE": "あなたの生年月日は、このオファーの許容範囲外です。",
  "defaultMessages.step.docUpload.rejectionReasons.PAYSTUB_OUTDATED_LAST_30_DAYS": "過去30日以内に発行された給与明細をアップロードしてください。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_BIRTHDATE_OTHER": "提出した書類に示された生年月日が、確認フォームに記載された内容と一致しませんでした。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIELD_MISMATCH": "提供された書類のフィールドが、確認フォームに記載された内容と一致しませんでした。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_FIRST_NAME_OTHER": "提出した書類に示された名が、確認フォームに記載された内容と一致しませんでした。",
  "defaultMessages.step.docUpload.rejectionReasons.PERSON_LAST_NAME_OTHER": "提出した書類に示された姓が、確認フォームに記載された内容と一致しませんでした。",
  "defaultMessages.step.docUpload.rejectionReasons.RESTRICTED_DOCUMENT": "法的制限のため、アップロードされた政府発行の身分証明書を確認することができませんでした。",
  "defaultMessages.step.docUpload.reviewTime": "予想されるレビュー時間は {{estimatedReviewTime}} です。",
  "defaultMessages.step.docUpload.submitButtonLabel": "送信",
  "defaultMessages.step.docUpload.suggestedDocumentTypes": "推奨されるドキュメントの種類",
  "defaultMessages.step.docUpload.title": "続行するには、あなたのステータスを確認する書類をアップロードしてください",
  "defaultMessages.step.docUpload.uploadInfo.affiliation": "その組織との<strong>現在の所属</strong>",
  "defaultMessages.step.docUpload.uploadInfo.age.birthDate": "<strong>生年月日</strong>",
  "defaultMessages.step.docUpload.uploadInfo.age.consentDE": "私は年齢確認のために身分証明書のコピーの処理と保管に同意します。画像は自動的にコピーとして保存され、アップロード前にシリアル番号を黒く塗りつぶす権利があることを理解しています。",
  "defaultMessages.step.docUpload.uploadInfo.dateCurrentYear": "現在の学年度または現在の学期の日付",
  "defaultMessages.step.docUpload.uploadInfo.employment.company": "<strong>あなたの会社</strong>",
  "defaultMessages.step.docUpload.uploadInfo.employment.currentAffiliation": "その会社との<strong>現在の所属</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.currentAffiliation": "その組織とのあなたの現在の所属",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.emt.status": "その組織での現在の<strong>EMTステータス</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.firefighter.status": "その組織での現在の<strong>消防士ステータス</strong>",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.license": "ファーストレスポンダーとしてのあなたのステータスまたは資格",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.organization": "<strong>組織</strong>名",
  "defaultMessages.step.docUpload.uploadInfo.firstResponder.police.status": "その組織での現在の<strong>警察ステータス</strong>",
  "defaultMessages.step.docUpload.uploadInfo.fullName": "このフォームに入力した<strong>フルネーム</strong>",
  "defaultMessages.step.docUpload.uploadInfo.identity.validDate": "現在有効な日付",
  "defaultMessages.step.docUpload.uploadInfo.institutionName": "完全または略称の<strong>学術機関名</strong>またはロゴ",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.licenseStatus": "<strong>専門的な資格および/または認定ステータス</strong>",
  "defaultMessages.step.docUpload.uploadInfo.licensedProfessional.validDate": "現在<strong>有効な日付</strong>",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.ebtNumber": "EBTカード番号",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.fullName": "あなたのフルネーム",
  "defaultMessages.step.docUpload.uploadInfo.lowIncome.validDate": "<strong>有効な発行日</strong>（過去12か月以内）または有効期限（有効でなければならない）",
  "defaultMessages.step.docUpload.uploadInfo.medical.medicalRole": "あなたの<strong>医療専門家</strong>としての役割",
  "defaultMessages.step.docUpload.uploadInfo.medical.status": "あなたの医療専門家としての状況",
  "defaultMessages.step.docUpload.uploadInfo.medical.validDate": "現在有効な<strong>日付</strong>",
  "defaultMessages.step.docUpload.uploadInfo.military.activeDuty.status": "現在の<strong>現役</strong>状況",
  "defaultMessages.step.docUpload.uploadInfo.military.currentAffiliation": "軍隊との現在の所属関係",
  "defaultMessages.step.docUpload.uploadInfo.military.dischargeDate": "除隊日（該当する場合）",
  "defaultMessages.step.docUpload.uploadInfo.military.goldStarFamily.status": "現在の<strong>軍人家族</strong>ステータス",
  "defaultMessages.step.docUpload.uploadInfo.military.militaryFamily.status": "現在の<strong>軍人家族</strong>ステータス",
  "defaultMessages.step.docUpload.uploadInfo.military.militaryRetiree.status": "<strong>退職者</strong>ステータス",
  "defaultMessages.step.docUpload.uploadInfo.military.reservist.status": "現在の<strong>予備役</strong>状況",
  "defaultMessages.step.docUpload.uploadInfo.military.serviceBranch": "<strong>服務部門</strong>",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsDependent": "あなたの名前、姓、有効な日付、ステータスが明確に記載された書類をアップロードしてください",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsMilitaryIdContent": "法律上、SheerIDは軍人IDカードのコピーを処理することができません。",
  "defaultMessages.step.docUpload.uploadInfo.military.uploadInstructionsMilitaryIdTitle": "軍人IDの写真をアップロードしないでください。",
  "defaultMessages.step.docUpload.uploadInfo.military.veteran.status": "<strong>退役軍人</strong>ステータス",
  "defaultMessages.step.docUpload.uploadInfo.organization": "<strong>組織名</strong>",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.address": "<strong>新しい住所</strong>",
  "defaultMessages.step.docUpload.uploadInfo.recentMover.validDate": "最近の引っ越しの<strong>有効な日付</strong>",
  "defaultMessages.step.docUpload.uploadInfo.senior.birthDate": "<strong>生年月日</strong>",
  "defaultMessages.step.docUpload.uploadInfo.student.enrollmentDate": "現在の学期への入学を証明する日付（または過去3か月以内）",
  "defaultMessages.step.docUpload.uploadInfo.student.graduate.degreeConferral": "<strong>学位授与の証明</strong>（例：「学位授与済み」ステータスまたは卒業日）",
  "defaultMessages.step.docUpload.uploadInfo.student.school": "あなたの学校",
  "defaultMessages.step.docUpload.uploadInfo.teacher.currentSchoolYear": "現在の学年度の日付",
  "defaultMessages.step.docUpload.uploadInfo.teacher.school": "あなたの学校",
  "defaultMessages.step.docUpload.whatHappensNext": "次に何が起こりますか？",
  "defaultMessages.step.docUpload.whoIsSheerId": "書類の審査は、ステータス確認を専門とする信頼できるパートナーのSheerIDが担当しています。",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.alternative": "職場のメールアドレスにアクセスできませんか？",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.email.label": "職場のメールアドレス",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.email.send": "メールを送信",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.subtitle": "雇用主が提供したメールアドレスを入力してください。確認リンクをお送りします",
  "defaultMessages.step.emailLoop.collectOrganizationEmail.title": "職場のメールアドレスを使用して確認する",
  "defaultMessages.step.emailLoop.errors.invalidEmail": "このメールアドレスは即時確認には有効ではありません。雇用主が提供したメールアドレスを使用するか、以下にドキュメントをアップロードしてください。",
  "defaultMessages.step.emailLoop.errors.resend": "メール送信エラー",
  "defaultMessages.step.emailLoop.resendButton": "メールを再送信",
  "defaultMessages.step.emailLoop.skipEmail": "メールが見つかりませんか？迷惑メールフォルダーを確認するか、",
  "defaultMessages.step.emailLoop.skipEmail2": "メール",
  "defaultMessages.step.emailLoop.skipEmailCTA": "再送信",
  "defaultMessages.step.emailLoop.subtitle2": "(verify@sheerid.com) から届いた SheerID のメールを開き、リンクを選択して続行してください。これにより、そのメールアカウントにアクセスできることを確認できます。",
  "defaultMessages.step.emailLoop.subtitleWithEmail": "認証手続きを続行するために、{email} にパーソナライズされたリンクを送信しました。",
  "defaultMessages.step.emailLoop.subtitleWithoutEmail": "認証手続きを続行するために、あなたのメールアドレスにパーソナライズされたリンクを送信しました。",
  "defaultMessages.step.emailLoop.successResend": "メールを正常に再送信しました。",
  "defaultMessages.step.emailLoop.title": "メールを確認してください",
  "defaultMessages.step.error.errorId.expiredProgram.buttonText": "他のオファーを見る",
  "defaultMessages.step.error.errorId.expiredProgram.title": "オファーが売り切れました！",
  "defaultMessages.step.error.errorId.inactiveProgram.buttonText": "他のオファーを見る",
  "defaultMessages.step.error.errorId.inactiveProgram.title": "オファーが売り切れました！",
  "defaultMessages.step.error.errorId.ineligibleOrganization.title": "お客様の資格を確認できませんでした。",
  "defaultMessages.step.error.errorId.missingRequiredExternalId.title": "ログインしてください。",
  "defaultMessages.step.error.errorId.missingRequiredMetadata.title": "ログインしてください。",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.buttonText": "他のオファーを見る",
  "defaultMessages.step.error.errorId.noRemainingRewardCodes.title": "オファーが売り切れました！",
  "defaultMessages.step.error.errorId.unauthorizedAccountStatus.buttonText": "サポートに連絡",
  "defaultMessages.step.error.errorId.unauthorizedAccountStatus.title": "オファーは一時停止中です！",
  "defaultMessages.step.error.errorId.verificationLimitExceeded.title": "確認制限を超えました",
  "defaultMessages.step.error.title": "認証を続行できませんでした",
  "defaultMessages.step.idCheckLoop.continue": "続ける",
  "defaultMessages.step.idCheckLoop.countrySelector.title": "発行国",
  "defaultMessages.step.idCheckLoop.disclaimer": "SheerID は {companyName} の信頼できるパートナーであり、第三者 {serviceType} を使用して本人確認を処理します。",
  "defaultMessages.step.idCheckLoop.docTypeSelector.subtitle": "カメラ付きの携帯電話またはウェブカメラ付きのコンピュータへのアクセスが必要です。",
  "defaultMessages.step.idCheckLoop.docTypeSelector.title": "書類を選択してください",
  "defaultMessages.step.idCheckLoop.docTypes.driverLicense.subtitle": "表面と裏面",
  "defaultMessages.step.idCheckLoop.docTypes.driverLicense.title": "運転免許証",
  "defaultMessages.step.idCheckLoop.docTypes.identityCard.subtitle": "表面と裏面",
  "defaultMessages.step.idCheckLoop.docTypes.identityCard.title": "政府発行のID",
  "defaultMessages.step.idCheckLoop.docTypes.passport.subtitle": "写真ページ",
  "defaultMessages.step.idCheckLoop.docTypes.passport.title": "パスポート",
  "defaultMessages.step.idCheckLoop.docTypes.residencePermit.subtitle": "表面と裏面",
  "defaultMessages.step.idCheckLoop.docTypes.residencePermit.title": "在留許可証",
  "defaultMessages.step.idCheckLoop.regula.addBackImage": "IDの裏面を追加する",
  "defaultMessages.step.idCheckLoop.regula.addFontImage": "IDの表面を追加する",
  "defaultMessages.step.idCheckLoop.regula.info.subtitle": "運転免許証、州発行のID、パスポート、または在留許可証。",
  "defaultMessages.step.idCheckLoop.regula.info.title": "政府発行のIDの写真",
  "defaultMessages.step.idCheckLoop.regula.sdk.imageQualityError": "画像に品質の問題があります。鮮明で、明るく照らされており、すべての詳細が見えることを確認してください。",
  "defaultMessages.step.idCheckLoop.regula.sdk.imageQualityErrorTitle": "書類を処理できませんでした",
  "defaultMessages.step.idCheckLoop.regula.sdk.rejectedImageNextStep": "再度撮影してアップロードしてください。",
  "defaultMessages.step.idCheckLoop.regula.sdk.subtitle": "確認を続けるには、政府発行のIDの写真を提出してください。",
  "defaultMessages.step.idCheckLoop.regula.sdk.title": "身分証明書のアップロード",
  "defaultMessages.step.idCheckLoop.regula.sdk.uploadAgain": "再アップロード",
  "defaultMessages.step.idCheckLoop.regula.submit": "送信",
  "defaultMessages.step.idCheckLoop.regula.terms": "「続ける」をクリックすることで、{privacyPolicyLink}および{termsOfService}を読み、理解し、同意したことを確認します。",
  "defaultMessages.step.idCheckLoop.regula.title": "続けるには、お客様の身元を確認する必要があります。",
  "defaultMessages.step.idCheckLoop.regula.uploadFileError": "ファイルのアップロード中にエラーが発生しました。もう一度お試しください。",
  "defaultMessages.step.idCheckLoop.regula.uploadSubtitle": "書類の情報が読みやすいことを確認してください。光の反射を避けてください。",
  "defaultMessages.step.idCheckLoop.regula.uploadTitle": "政府発行のIDをアップロードする",
  "defaultMessages.step.idCheckLoop.steps.docReview.title": "ステータスの証明をアップロードする",
  "defaultMessages.step.idCheckLoop.steps.idCheck.subtitle": "運転免許証、州発行のID、パスポート、または在留許可証などの有効な政府発行の書類。",
  "defaultMessages.step.idCheckLoop.steps.idCheck.title": "政府発行のIDの写真を撮る",
  "defaultMessages.step.idCheckLoop.steps.selfie.title": "自撮り写真を撮る",
  "defaultMessages.step.idCheckLoop.subtitle": "カメラ付きの携帯電話またはウェブカメラ付きのコンピュータへのアクセスが必要です。",
  "defaultMessages.step.idCheckLoop.terms": "「続ける」をクリックすることで、{scanPolicy}、{privacyPolicyLink}および{termsOfService}を読み、理解し、同意したことを確認します。",
  "defaultMessages.step.idCheckLoop.title": "あなたの身元を確認しましょう",
  "defaultMessages.step.override.errors.codeOverrideLimit": "オーバーライドコードの上限を超えました。",
  "defaultMessages.step.override.errors.invalidCode": "無効なオーバーライドコードです。",
  "defaultMessages.step.override.submitOverrideCodeButtonLabel": "オーバーライドコードを送信",
  "defaultMessages.step.override.subtitle": "店舗で確認を行っており、資格を証明する書類をお持ちでない場合、または書類のアップロードに困難がある場合は、店舗スタッフに資格の確認をご依頼ください。",
  "defaultMessages.step.override.subtitle2": "店舗スタッフは、お客様がオファーの対象であると判断した場合、以下に確認オーバーライドコードを入力することができます。",
  "defaultMessages.step.override.title": "ステータスを確認できません",
  "defaultMessages.step.override.verificationOverrideCodeLabel": "確認オーバーライドコード",
  "defaultMessages.step.pending.idCheckLoop.subtitle": "しばらくお待ちください。通常、処理時間は数分以内です。",
  "defaultMessages.step.pending.idCheckLoop.subtitle2": "確認が完了しましたら、メールをお送りします。",
  "defaultMessages.step.pending.idCheckLoop.title": "書類を確認中です",
  "defaultMessages.step.pending.subtitle": "SheerIDはお客様の書類を確認し、ステータスを確認しています。このプロセスには最大{{maxReviewTime}}かかる場合があります。",
  "defaultMessages.step.pending.subtitle2": "このままお待ちいただくか、このページを閉じても構いません。",
  "defaultMessages.step.pending.subtitle3": "確認が完了しましたら、メールでお知らせします。",
  "defaultMessages.step.pending.titleReview": "書類を受け取りました",
  "defaultMessages.step.pending.turnaroundTime": "確認には通常 {{estimatedReviewTime}} かかりますが、混雑時には最大 {{maxReviewTime}} かかる場合があります。",
  "defaultMessages.step.personalInfo.captcha.error": "人間であることを確認できません。接続を確認するか、広告ブロッカーを無効にするか、ページを更新して再試行してください。",
  "defaultMessages.step.personalInfo.captcha.loading": "人間であることを確認中です。ボタンが有効になったら、もう一度「{submitButtonText}」をクリックしてください。",
  "defaultMessages.step.personalInfo.captcha.retryButton": "再試行",
  "defaultMessages.step.personalInfo.captcha.success": "確認が完了しました。確認を続行するには、もう一度「{submitButtonText}」をクリックしてください。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.closing": "お楽しみください！",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.message": "Verify@sheerid.com から、確認済みオファーの引き換えに関する詳細が記載された確認メールを再送しました。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.existingVerificationFound.title": "以前にもこちらをご利用いただきました！",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.needChanges": "変更が必要ですか？",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.closing": "Verify@sheerid.com から、次のステップを記載した最後のメールを再送しました。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.message": "このメールアドレスは進行中の確認手続きに関連付けられています。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.pendingVerification.title": "すでに開始されているようです。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.proceedHere": "こちらで続行",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.closing": "Verify@sheerid.com から、次のステップを記載した最後のメールを再送しました。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.message": "このメールアドレスは進行中の確認手続きに関連付けられており、別の書類のアップロードが必要です。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.rejectedVerification.title": "すでに開始されているようです。",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.sendAgain": "再送信",
  "defaultMessages.step.personalInfo.emailFirstCollectInfo.sent": "送信済み！",
  "defaultMessages.step.personalInfo.submitButtonText": "確認して続行",
  "defaultMessages.step.personalInfo.verifyingSubtitle": "ほんの少し時間がかかります",
  "defaultMessages.step.personalInfo.verifyingTitle": "ステータスを確認中",
  "defaultMessages.step.smsLoop.errors.codeExpired": "確認コードを検証できませんでした。",
  "defaultMessages.step.smsLoop.errors.codeResendLimit": "再試行の最大回数に達しました。",
  "defaultMessages.step.smsLoop.errors.codeVerification": "確認コードを検証できませんでした。",
  "defaultMessages.step.smsLoop.errors.resend": "SMSメッセージの送信エラー",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber1": "番号が間違っていますか？クリック",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber2": "こちら",
  "defaultMessages.step.smsLoop.incorrectNumber.incorrectNumber3": "{companyName}に戻る",
  "defaultMessages.step.smsLoop.resendButton": "再送信",
  "defaultMessages.step.smsLoop.submitButton": "送信",
  "defaultMessages.step.smsLoop.successResend": "SMSメッセージが正常に再送信されました",
  "defaultMessages.step.smsLoop.titleWithNumber": "{number}で終わる携帯電話番号にSMSメッセージを送信しました。ここにコードを入力してください。",
  "defaultMessages.step.smsLoop.titleWithoutNumber": "携帯電話番号にSMSを送信しました。こちらにコードを入力してください。",
  "defaultMessages.step.smsLoop.verificationCode": "確認コード",
  "defaultMessages.step.sso.alternative": "資格証明書をアップロードしても確認できます",
  "defaultMessages.step.sso.cancel": "書類をアップロード",
  "defaultMessages.step.sso.login": "学校にサインイン",
  "defaultMessages.step.sso.preheader": "最速の方法",
  "defaultMessages.step.sso.subtitle": "学校のウェブポータルにサインインしてください。新しいタブで開きます。",
  "defaultMessages.step.sso.subtitle2": "サインインできませんか？",
  "defaultMessages.step.sso.title": "学校の認証情報を使用して確認",
  "defaultMessages.step.success.copyCouponCode": "クーポンコードをコピー",
  "defaultMessages.step.success.emailNotification": "特典利用方法の説明が含まれた確認メールをお送りしました。{email} からのメールをご確認ください。",
  "defaultMessages.step.success.rememberMe.consumerFound.button": "「Remember Me」に保存",
  "defaultMessages.step.success.rememberMe.consumerFound.description": "SheerIDの「Remember Me」サービスを使用して、{companyName}や他のブランドの将来のオファーのために新しい情報を保存します。",
  "defaultMessages.step.success.rememberMe.consumerFound.title": "プロフィールを更新",
  "defaultMessages.step.success.rememberMe.consumerNotFound.button": "今すぐ登録",
  "defaultMessages.step.success.rememberMe.consumerNotFound.description": "SheerIDの「Remember Me」サービスを使用して、{companyName}や他のブランドの将来のオファーへより素早くアクセスできます。",
  "defaultMessages.step.success.rememberMe.consumerNotFound.title": "1クリック確認のために情報を保存",
  "defaultMessages.step.success.verificationOnly": "SheerIDは確認のみを担当します。承認されましたので、プロモーション条件に関するすべての質問は{companyName}カスタマーサービスにお問い合わせください。",
  "defaultMessages.step.thirdPartyLoop.error": "プロバイダーはサポートされていません",
  "defaultMessages.step.thirdPartyLoop.signzy.cancel": "本人確認書類をアップロード",
  "defaultMessages.step.thirdPartyLoop.signzy.login": "DigiLockerにサインイン",
  "defaultMessages.step.thirdPartyLoop.signzy.subtitle": "DigiLockerのログイン情報を使用して確認",
  "defaultMessages.step.thirdPartyLoop.signzy.title": "DigiLockerを使用して確認",
  "defaultMessages.streetAddress": "住所",
  "defaultMessages.studentInfoShared": "ここに入力された情報は確認目的で使用され、{companyName}と共有されます。",
  "defaultMessages.tryAgain": "再試行",
  "defaultMessages.tryFullNameTips": "略語や頭字語を使用するのではなく、学術機関の正式名称を入力してみてください。",
  "defaultMessages.universityName": "大学名",
  "defaultMessages.verificationPurposesOnly": "確認目的のみに使用",
  "defaultMessages.verifyAndContinue": "確認して続行",
  "defaultMessages.verifyMyEmploymentStatus": "従業員ステータスを確認",
  "defaultMessages.verifyMyFirstResponderStatus": "ファーストレスポンダーのステータスを確認",
  "defaultMessages.verifyMyIdentityStatus": "本人確認",
  "defaultMessages.verifyMyLicensedProfessionalStatus": "ライセンスを持つ専門家のステータスを確認",
  "defaultMessages.verifyMyLowIncomeStatus": "ステータスを確認",
  "defaultMessages.verifyMyMedicalProfessionalStatus": "医療専門家のステータスを確認",
  "defaultMessages.verifyMyMembershipStatus": "会員ステータスを確認",
  "defaultMessages.verifyMyMilitaryStatus": "軍人ステータスを確認",
  "defaultMessages.verifyMyMoverStatus": "新しい移住者のステータスを確認",
  "defaultMessages.verifyMyStudentStatus": "学生ステータスを確認",
  "defaultMessages.verifyMyTeacherStatus": "教育者ステータスを確認",
  "defaultMessages.warningId.openOrganization": "データベースにその名前の一致が見つかりませんでした。スペルを再確認してください。正しければ、そのまま続けてください！",
  "segmentMessages.age.emailExplanation": "個人メールアドレスを推奨します",
  "segmentMessages.age.step.docUpload.title": "続行するには、年齢を確認する書類をアップロードしてください",
  "segmentMessages.age.step.docUpload.uploadInstructions": "以下を示す政府発行の書類をアップロードしてください",
  "segmentMessages.age.step.docUpload.whoIsSheerId": "書類審査はSheerIDが担当します。SheerIDは年齢確認を専門とする信頼できるパートナーです。",
  "segmentMessages.age.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの資格を得るには、特定の年齢である必要があります。<br><br>{{companyName}}は信頼できるパートナーであるSheerIDを使用してお客様の年齢を確認します。SheerIDはお客様の資格確認に必要な情報のみを収集します。追加情報や書類の提出をお願いする場合があります。",
  "segmentMessages.age.step.personalInfo.submitButtonText": "確認して続ける",
  "segmentMessages.age.step.personalInfo.subtitle": "現在の年齢を確認してください。",
  "segmentMessages.age.step.personalInfo.title": "特別オファーをアンロック",
  "segmentMessages.age.step.personalInfo.tryAgain.subtitle": "フルネームと生年月日は、政府発行の書類に記載されているものと一致する必要があります。",
  "segmentMessages.age.step.personalInfo.tryAgain.title": "お名前と生年月日を確認してください",
  "segmentMessages.age.step.personalInfo.verifyingTitle": "年齢を確認中",
  "segmentMessages.age.step.success.redirectButtonText": "続ける",
  "segmentMessages.age.step.success.subtitle": "この特別オファーの資格が付与されました。",
  "segmentMessages.age.step.success.title": "確認が完了しました",
  "segmentMessages.employment.addressExplanation": "自宅の住所を使用してください",
  "segmentMessages.employment.emailExplanation": "お持ちの場合は職場のメールアドレスをご使用ください",
  "segmentMessages.employment.step.docUpload.title": "続行するには、雇用状況を確認する書類をアップロードしてください",
  "segmentMessages.employment.step.docUpload.uploadInstructions": "以下を示す公的書類をアップロードしてください",
  "segmentMessages.employment.step.docUpload.whoIsSheerId": "書類の審査は、従業員の確認を専門とする信頼できるパートナーSheerIDが担当します。",
  "segmentMessages.employment.step.personalInfo.howDoesVerifyingWorkDetails": "{{companyName}}は、選定された企業の全現役従業員向けにこの特別オファーを設けました。<br><br>{{companyName}}は信頼できるパートナーであるSheerIDを使用して、お客様が現在雇用されていることを確認します。SheerIDはお客様の資格確認に必要な情報のみを収集します。追加情報や書類の提出をお願いする場合があります。",
  "segmentMessages.employment.step.personalInfo.submitButtonText": "従業員ステータスを確認する",
  "segmentMessages.employment.step.personalInfo.subtitle": "対象となる企業の現役従業員であることを確認してください。",
  "segmentMessages.employment.step.personalInfo.title": "この従業員限定オファーをアンロック",
  "segmentMessages.employment.step.personalInfo.tryAgain.subtitle": "ご提供いただいた情報は、公式書類と一致する必要があります。",
  "segmentMessages.employment.step.personalInfo.tryAgain.title": "入力した情報を確認してください",
  "segmentMessages.employment.step.personalInfo.verifyingTitle": "雇用状況を確認中",
  "segmentMessages.employment.step.sso.alternative": "雇用証明をアップロードして確認することもできます",
  "segmentMessages.employment.step.sso.cancel": "雇用証明をアップロード",
  "segmentMessages.employment.step.sso.login": "メールアカウントにサインイン",
  "segmentMessages.employment.step.sso.subtitle": "会社のメールポータルにサインインしてください。新しいタブで開きます。",
  "segmentMessages.employment.step.sso.subtitle2": "メールにサインインできませんか？",
  "segmentMessages.employment.step.sso.title": "会社提供のメール認証情報を使用して確認",
  "segmentMessages.employment.step.success.redirectButtonText": "続ける",
  "segmentMessages.employment.step.success.subtitle": "この特別オファーの資格が付与されました。",
  "segmentMessages.employment.step.success.title": "確認が完了しました",
  "segmentMessages.firstResponder.emailExplanation": "お持ちの場合は職場のメールアドレスをご使用ください",
  "segmentMessages.firstResponder.step.docUpload.title": "続行するには、ファーストレスポンダーの状況を確認する書類をアップロードしてください",
  "segmentMessages.firstResponder.step.docUpload.uploadInstructions": "以下を示す公的書類をアップロードしてください",
  "segmentMessages.firstResponder.step.docUpload.whoIsSheerId": "書類の審査は、ファーストレスポンダーの確認を専門とする信頼できるパートナーSheerIDが担当します。",
  "segmentMessages.firstResponder.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーは、すべての米国ファーストレスポンダーおよび緊急要員（警察官、EMT、救急救命士、消防士を含む）が対象です。<br><br>{{companyName}}は信頼できるパートナーであるSheerIDを使用して、お客様がアクティブなファーストレスポンダーであることを確認します。SheerIDはお客様の資格確認に必要な情報のみを収集します。追加情報や書類の提出をお願いする場合があります。",
  "segmentMessages.firstResponder.step.personalInfo.submitButtonText": "ファーストレスポンダーステータスを確認する",
  "segmentMessages.firstResponder.step.personalInfo.subtitle": "アクティブなファーストレスポンダーであることを確認してください。",
  "segmentMessages.firstResponder.step.personalInfo.title": "このファーストレスポンダー限定オファーをアンロック",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.subtitle": "フルネーム、組織名、メールアドレスは、所属機関の記録と一致する必要があります。",
  "segmentMessages.firstResponder.step.personalInfo.tryAgain.title": "お名前、メール、組織を確認してください",
  "segmentMessages.firstResponder.step.personalInfo.verifyingTitle": "ファーストレスポンダーのステータスを確認中",
  "segmentMessages.firstResponder.step.success.redirectButtonText": "続ける",
  "segmentMessages.firstResponder.step.success.subtitle": "この特別オファーの資格が付与されました。",
  "segmentMessages.firstResponder.step.success.title": "確認が完了しました",
  "segmentMessages.identity.emailExplanation": "個人のメールアドレスの使用を推奨します",
  "segmentMessages.identity.step.docUpload.title": "続けるには、あなたのステータスを確認する書類をアップロードしてください",
  "segmentMessages.identity.step.docUpload.uploadInstructions": "次の情報を示す政府発行の書類をアップロードしてください",
  "segmentMessages.identity.step.docUpload.whoIsSheerId": "書類の審査は、ステータス確認を専門とする信頼できるパートナーであるSheerIDが担当します。",
  "segmentMessages.identity.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、有効な運転免許証が必要です。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用してあなたの身元を確認します。SheerIDはあなたの資格確認に役立つ情報のみを収集します。追加情報や書類の提出が求められる場合があります。",
  "segmentMessages.identity.step.personalInfo.submitButtonText": "身元を確認する",
  "segmentMessages.identity.step.personalInfo.subtitle": "現在の身元を確認してください。",
  "segmentMessages.identity.step.personalInfo.title": "あなたの特別オファーをアンロックする",
  "segmentMessages.identity.step.personalInfo.tryAgain.subtitle": "ご入力の情報は政府発行の書類の内容と一致する必要があります。",
  "segmentMessages.identity.step.personalInfo.tryAgain.title": "お名前と他の項目を確認してください",
  "segmentMessages.identity.step.personalInfo.verifyingTitle": "あなたの身元を確認中です",
  "segmentMessages.identity.step.success.redirectButtonText": "続ける",
  "segmentMessages.identity.step.success.subtitle": "この特別オファーの対象になりました。",
  "segmentMessages.identity.step.success.title": "確認が完了しました",
  "segmentMessages.licensedProfessional.emailExplanation": "職場のメールアドレスをお持ちの場合はそちらをご使用ください",
  "segmentMessages.licensedProfessional.step.docUpload.title": "続けるには、あなたが資格を持つ専門家であることを証明する書類をアップロードしてください",
  "segmentMessages.licensedProfessional.step.docUpload.uploadInstructions": "次の情報を示す政府発行の書類をアップロードしてください",
  "segmentMessages.licensedProfessional.step.docUpload.whoIsSheerId": "書類の審査は、資格を持つ専門家の確認を専門とする信頼できるパートナーであるSheerIDが担当します。",
  "segmentMessages.licensedProfessional.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、指定した分野において現行の専門資格・ライセンスを保有している必要があります。対象となる分野はこのフォームのステータス選択欄に表示されています。<br><br>{{companyName}}は、あなたが資格を持つ専門家であることを確認するために、信頼できるパートナーであるSheerIDを使用します。SheerIDはあなたの資格確認に役立つ情報のみを収集します。追加情報や書類の提出が求められる場合があります。",
  "segmentMessages.licensedProfessional.step.personalInfo.submitButtonText": "資格のある専門家としての状況を確認する",
  "segmentMessages.licensedProfessional.step.personalInfo.subtitle": "あなたの専門分野において資格・ライセンスを保有していることを確認してください。",
  "segmentMessages.licensedProfessional.step.personalInfo.title": "この特別オファーのロックを解除する",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.subtitle": "ご入力の情報は政府発行の書類の内容と一致する必要があります。",
  "segmentMessages.licensedProfessional.step.personalInfo.tryAgain.title": "お名前と他の項目を確認してください",
  "segmentMessages.licensedProfessional.step.personalInfo.verifyingTitle": "あなたのライセンスを確認中です",
  "segmentMessages.licensedProfessional.step.success.redirectButtonText": "続ける",
  "segmentMessages.licensedProfessional.step.success.subtitle": "この特別オファーの対象になりました。",
  "segmentMessages.licensedProfessional.step.success.title": "確認が完了しました",
  "segmentMessages.lowIncome.addressExplanation": "自宅の住所をご使用ください",
  "segmentMessages.lowIncome.step.docUpload.title": "続行するには、承認された政府支援プログラムへの参加を確認する書類をアップロードしてください",
  "segmentMessages.lowIncome.step.docUpload.uploadInstructions": "次の情報を示す公式書類をアップロードしてください",
  "segmentMessages.lowIncome.step.docUpload.whoIsSheerId": "書類の審査は、資格確認を専門とする信頼できるパートナーであるSheerIDが行います。",
  "segmentMessages.lowIncome.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、現在対象となる政府支援プログラムの資格を満たしている必要があります。このオファーの対象となる政府支援プログラムは、下のボックスに記載されています。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用して、お客様がこれらの給付金の受給者であることを確認します。SheerIDは、資格確認に必要な情報のみを収集します。追加の情報または書類の提出を求める場合があります。",
  "segmentMessages.lowIncome.step.personalInfo.submitButtonText": "自分のステータスを確認する",
  "segmentMessages.lowIncome.step.personalInfo.subtitle": "対象となる政府支援プログラムの資格を満たしていることを確認してください。",
  "segmentMessages.lowIncome.step.personalInfo.title": "この特別オファーのロックを解除する",
  "segmentMessages.lowIncome.step.personalInfo.tryAgain.subtitle": "ご入力の情報は政府発行の書類の内容と一致する必要があります。",
  "segmentMessages.lowIncome.step.personalInfo.tryAgain.title": "氏名（フルネーム）と他の項目を確認してください",
  "segmentMessages.lowIncome.step.personalInfo.verifyingTitle": "あなたのステータスを確認中です",
  "segmentMessages.lowIncome.step.success.redirectButtonText": "続ける",
  "segmentMessages.lowIncome.step.success.subtitle": "この特別オファーの対象になりました。",
  "segmentMessages.lowIncome.step.success.title": "確認が完了しました",
  "segmentMessages.medical.emailExplanation": "職場のメールアドレスをお持ちの場合はそちらをご使用ください",
  "segmentMessages.medical.step.docUpload.title": "続行するには、医療専門家としてのステータスを確認する書類をアップロードしてください",
  "segmentMessages.medical.step.docUpload.uploadInstructions": "次の情報を示す公式書類をアップロードしてください",
  "segmentMessages.medical.step.docUpload.whoIsSheerId": "書類の審査は、医療専門家としての資格確認を専門とする信頼できるパートナーであるSheerIDが行います。",
  "segmentMessages.medical.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、認可を受けた資格のある医療専門家である必要があります。これには、医師、看護師、薬剤師、その他の医療専門家が含まれます。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用して、医療専門家としてのステータスを確認します。SheerIDは、資格確認に必要な情報のみを収集します。追加の情報または書類の提出を求める場合があります。",
  "segmentMessages.medical.step.personalInfo.submitButtonText": "医療専門家としてのステータスを確認する",
  "segmentMessages.medical.step.personalInfo.subtitle": "認可を受けた医療専門家としてのステータスを確認してください。",
  "segmentMessages.medical.step.personalInfo.title": "医療専門家向けのこの特別オファーを利用する",
  "segmentMessages.medical.step.personalInfo.tryAgain.subtitle": "お名前、生年月日、所属組織が当社の記録と一致する必要があります",
  "segmentMessages.medical.step.personalInfo.tryAgain.title": "お名前、生年月日、所属組織が正しいかご確認ください",
  "segmentMessages.medical.step.personalInfo.verifyingTitle": "医療専門家としてのステータスを確認中",
  "segmentMessages.medical.step.sso.alternative": "雇用主ポータルを使用して確認することもできます",
  "segmentMessages.medical.step.sso.login": "雇用主ポータルにサインイン",
  "segmentMessages.medical.step.sso.subtitle": "組織の認証情報を使用してステータスを確認してください",
  "segmentMessages.medical.step.sso.title": "医療従事者のステータスを確認する",
  "segmentMessages.medical.step.success.redirectButtonText": "続ける",
  "segmentMessages.medical.step.success.subtitle": "この特別オファーの対象になりました。",
  "segmentMessages.medical.step.success.title": "確認が完了しました",
  "segmentMessages.member.step.docUpload.title": "続行するには、対象組織での会員資格を確認する書類をアップロードしてください",
  "segmentMessages.member.step.docUpload.uploadInstructions": "次の情報を示す公式書類をアップロードしてください",
  "segmentMessages.member.step.docUpload.whoIsSheerId": "書類の審査は、会員としての資格確認を専門とする信頼できるパートナーであるSheerIDが行います。",
  "segmentMessages.member.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、対象組織の有効な会員である必要があります。このオファーの対象組織は、下のボックスに記載されています。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用して、会員資格を確認します。SheerIDは、資格確認に必要な情報のみを収集します。追加の情報または書類の提出を求める場合があります。",
  "segmentMessages.member.step.personalInfo.submitButtonText": "会員ステータスを確認する",
  "segmentMessages.member.step.personalInfo.subtitle": "対象組織の有効な会員資格を確認してください。",
  "segmentMessages.member.step.personalInfo.title": "会員向けのこの特別オファーを利用する",
  "segmentMessages.member.step.personalInfo.tryAgain.subtitle": "お客様の情報は組織の公式記録と一致する必要があります",
  "segmentMessages.member.step.personalInfo.tryAgain.title": "提供された情報が正しいかご確認ください",
  "segmentMessages.member.step.personalInfo.verifyingTitle": "会員資格を確認中",
  "segmentMessages.member.step.success.redirectButtonText": "続ける",
  "segmentMessages.member.step.success.subtitle": "この特別オファーの対象になりました。",
  "segmentMessages.member.step.success.title": "確認が完了しました",
  "segmentMessages.military.emailExplanation": "個人のメールアドレスの使用を推奨します",
  "segmentMessages.military.step.docUpload.title": "続行するには、軍の身分を確認する書類をアップロードしてください",
  "segmentMessages.military.step.docUpload.uploadInstructions": "次の情報を示す政府発行の書類をアップロードしてください",
  "segmentMessages.military.step.docUpload.whoIsSheerId": "書類の審査は、軍人としての資格確認を専門とする信頼できるパートナーであるSheerIDが行います。",
  "segmentMessages.military.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、現役、退役、または退役軍人として軍の一員であることが必要です。これには、現役軍人、予備役、退役軍人、およびその家族が含まれます。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用して、軍の身分を確認します。SheerIDは、資格確認に必要な情報のみを収集します。追加の情報または書類の提出を求める場合があります。",
  "segmentMessages.military.step.personalInfo.submitButtonText": "軍の身分を確認する",
  "segmentMessages.military.step.personalInfo.subtitle": "現役、退役、または退役軍人として軍の一員であることを確認してください。",
  "segmentMessages.military.step.personalInfo.title": "軍関係者向けのこの特別オファーを利用する",
  "segmentMessages.military.step.personalInfo.tryAgain.subtitle": "お名前、生年月日、軍の部門が正しいかご確認ください",
  "segmentMessages.military.step.personalInfo.tryAgain.title": "お名前と生年月日を確認してください",
  "segmentMessages.military.step.personalInfo.verifyingTitle": "軍の身分を確認中",
  "segmentMessages.military.step.success.redirectButtonText": "続ける",
  "segmentMessages.military.step.success.subtitle": "この特別オファーの対象になりました。",
  "segmentMessages.military.step.success.title": "確認が完了しました",
  "segmentMessages.recentMover.emailExplanation": "個人のメールアドレスを推奨します",
  "segmentMessages.recentMover.step.docUpload.title": "続行するには、最近引越しをしたことを確認する書類をアップロードしてください",
  "segmentMessages.recentMover.step.docUpload.uploadInstructions": "以下を示す公式書類をアップロードしてください",
  "segmentMessages.recentMover.step.docUpload.whoIsSheerId": "書類の審査は、最近引越しをした方の確認を専門とする信頼できるパートナー、SheerIDが行います。",
  "segmentMessages.recentMover.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、過去60日以内に新しい住所に引越している必要があります。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用して、お客様が最近引越しをしたことを確認します。SheerIDは、資格確認に必要な情報のみを収集します。追加情報または書類の提出を求める場合があります。",
  "segmentMessages.recentMover.step.personalInfo.submitButtonText": "新居への引越しステータスを確認する",
  "segmentMessages.recentMover.step.personalInfo.subtitle": "最近引越しをしたことを確認してください。",
  "segmentMessages.recentMover.step.personalInfo.title": "この特別オファーをアンロックする",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.subtitle": "お名前（姓・名）と住所は、公式書類に記載されているものと一致する必要があります。",
  "segmentMessages.recentMover.step.personalInfo.tryAgain.title": "氏名と住所情報を確認してください",
  "segmentMessages.recentMover.step.personalInfo.verifyingTitle": "引越しステータスを確認中",
  "segmentMessages.recentMover.step.success.redirectButtonText": "続行",
  "segmentMessages.recentMover.step.success.subtitle": "この特別オファーの対象となりました。",
  "segmentMessages.recentMover.step.success.title": "確認が完了しました",
  "segmentMessages.senior.emailExplanation": "個人のメールアドレスを推奨します",
  "segmentMessages.senior.step.docUpload.title": "続行するには、年齢を確認する書類をアップロードしてください",
  "segmentMessages.senior.step.docUpload.uploadInstructions": "以下を示す政府発行の書類をアップロードしてください",
  "segmentMessages.senior.step.docUpload.whoIsSheerId": "書類の審査は、年齢確認を専門とする信頼できるパートナー、SheerIDが行います。",
  "segmentMessages.senior.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、一定の年齢である必要があります。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用して、お客様の年齢を確認します。SheerIDは、資格確認に必要な情報のみを収集します。追加情報または書類の提出を求める場合があります。",
  "segmentMessages.senior.step.personalInfo.submitButtonText": "確認して続行",
  "segmentMessages.senior.step.personalInfo.subtitle": "現在の年齢を確認してください。",
  "segmentMessages.senior.step.personalInfo.title": "あなたの特別オファーをアンロックする",
  "segmentMessages.senior.step.personalInfo.tryAgain.subtitle": "フルネームと生年月日は、政府発行の書類に記載されているものと一致する必要があります。",
  "segmentMessages.senior.step.personalInfo.tryAgain.title": "氏名と生年月日を確認してください",
  "segmentMessages.senior.step.personalInfo.verifyingTitle": "年齢を確認中",
  "segmentMessages.senior.step.success.redirectButtonText": "続行",
  "segmentMessages.senior.step.success.subtitle": "この特別オファーの対象となりました。",
  "segmentMessages.senior.step.success.title": "確認が完了しました",
  "segmentMessages.student.emailExplanation": "学生メールアドレスが推奨されます",
  "segmentMessages.student.schoolName": "学校",
  "segmentMessages.student.step.docUpload.title": "続行するには、学生であることを確認できる書類を1つ以上アップロードしてください。",
  "segmentMessages.student.step.docUpload.uploadInstructions": "学校発行の書類をアップロードしてください。以下を示すもの：",
  "segmentMessages.student.step.docUpload.whoIsSheerId": "書類の審査は、学生の確認を専門とする信頼できるパートナー、SheerIDが行います。",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.alternative": "学術メールアドレスにアクセスできませんか？",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.email.label": "学術メールアドレス",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.subtitle": "学術機関が提供するメールアドレスを入力してください。確認リンクをお送りします",
  "segmentMessages.student.step.emailLoop.collectOrganizationEmail.title": "学術メールアドレスを使って確認する",
  "segmentMessages.student.step.emailLoop.errors.invalidEmail": "このメールアドレスは即時確認には無効です。学術機関が提供するメールアドレスを使用するか、以下に書類をアップロードしてください。",
  "segmentMessages.student.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、現在、学位または資格を付与する認定教育機関に在籍している必要があります。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用して、お客様が現役の学生であることを確認します。SheerIDは、資格確認に必要な情報のみを収集します。追加情報または書類の提出を求める場合があります。",
  "segmentMessages.student.step.personalInfo.submitButtonText": "学生ステータスを確認する",
  "segmentMessages.student.step.personalInfo.subtitle": "学位を授与する学校の学生であることを確認してください。",
  "segmentMessages.student.step.personalInfo.title": "この学生限定オファーをアンロックする",
  "segmentMessages.student.step.personalInfo.tryAgain.subtitle": "フルネームと生年月日は、公式の学校記録に記載されているものと一致する必要があります。",
  "segmentMessages.student.step.personalInfo.tryAgain.title": "氏名と生年月日を確認してください",
  "segmentMessages.student.step.personalInfo.verifyingTitle": "学生ステータスを確認中",
  "segmentMessages.student.step.sso.alternative": "在籍証明書をアップロードすることでも確認できます",
  "segmentMessages.student.step.sso.cancel": "在籍証明書をアップロード",
  "segmentMessages.student.step.sso.login": "学術機関にサインインする",
  "segmentMessages.student.step.sso.subtitle": "現在の在籍状況を認証するために、所属する学術機関からサインインしてください。学校のポータルが新しいウィンドウで開きます。",
  "segmentMessages.student.step.sso.title": "学校のログイン情報を使用して認証する",
  "segmentMessages.student.step.success.redirectButtonText": "続行",
  "segmentMessages.student.step.success.subtitle": "この特別オファーの対象となりました。",
  "segmentMessages.student.step.success.title": "確認が完了しました",
  "segmentMessages.teacher.emailExplanation": "学校発行のメールアドレスである必要があります",
  "segmentMessages.teacher.schoolName": "学校名",
  "segmentMessages.teacher.schoolNamePlaceholder": "学校名",
  "segmentMessages.teacher.step.docUpload.title": "続行するには、教育者の身分を確認する書類をアップロードしてください",
  "segmentMessages.teacher.step.docUpload.uploadInstructions": "学校発行の書類をアップロードしてください。以下を示すもの：",
  "segmentMessages.teacher.step.docUpload.whoIsSheerId": "書類の審査は、教育者の確認を専門とする信頼できるパートナー、SheerIDが行います。",
  "segmentMessages.teacher.step.personalInfo.howDoesVerifyingWorkDetails": "このオファーの対象となるには、現在、認定教育機関で教育者、教員、またはスタッフとして勤務している必要があります。<br><br>{{companyName}}は、信頼できるパートナーであるSheerIDを使用して、お客様が現役の教育者、教員、またはスタッフであることを確認します。SheerIDは、資格確認に必要な情報のみを収集します。追加情報または書類の提出を求める場合があります。",
  "segmentMessages.teacher.step.personalInfo.submitButtonText": "教育者ステータスを確認する",
  "segmentMessages.teacher.step.personalInfo.subtitle": "認定教育機関の教育者、教員、またはスタッフであることを確認してください。",
  "segmentMessages.teacher.step.personalInfo.title": "この教育者限定オファーをアンロックする",
  "segmentMessages.teacher.step.personalInfo.tryAgain.subtitle": "フルネームとメールアドレスは、学校の記録に登録されているものと一致する必要があります。",
  "segmentMessages.teacher.step.personalInfo.tryAgain.title": "氏名とメールアドレスを確認してください",
  "segmentMessages.teacher.step.personalInfo.verifyingTitle": "教育者ステータスを確認中",
  "segmentMessages.teacher.step.success.redirectButtonText": "続行",
  "segmentMessages.teacher.step.success.subtitle": "この特別オファーの対象となりました。",
  "segmentMessages.teacher.step.success.title": "確認が完了しました",
  "segmentMessages.student.step.personalInfo.nameInstructions": "お名前を、公式の学校記録に記載されているとおりに正確に入力してください。",
  "segmentMessages.student.step.docUpload.uploadInfo.fullName": "学校記録に記載されているとおりの<strong>氏名</strong>",
  "defaultMessages.step.pending.uploadedDocument": "書類は正常にアップロードされ、現在確認中です。",
  "defaultMessages.step.docUpload.uploadInfo.expiration": "まだ過ぎていない有効期限",
  "defaultMessages.step.docUpload.uploadInfo.issueDate": "過去90日以内の発行日",
  "defaultMessages.step.docUpload.uploadInfo.enrollmentProof": "<strong>現在の在籍</strong>を証明するもので、次のいずれかで示されるもの：",
  "defaultMessages.contactSupport": "対象に該当すると思われる場合は、<faqLink>ヘルプセンター</faqLink>をご覧いただくか、<feedbackFormLink>SheerID サポートにお問い合わせください</feedbackFormLink>"
}
